// This file is automatically generated from Rails routes.
// DO NOT modify it manually.
// To regenerate, run: bin/rake gitlab:js:routes

import { __jsr } from '~/lib/utils/path_helpers/core';
import { resolveOrganizationScope, splitProjectFullPath } from '~/lib/utils/path_helpers/utils';


/**
 * Generates the Rails route:
 *
 * - href: `/:project_full_path/-/requirements_management/requirements/import_csv(.:format)`
 * - Path helper: `import_csv_project_requirements_management_requirements_path`
 * - URL helper: `import_csv_project_requirements_management_requirements_url`
 * - controller#action: `projects/requirements_management/requirements#import_csv`
 *
 * @param {string} projectFullPath
 * @param {object | undefined} options
 * @param {string | null | undefined} options.organizationPath Path of organization to nest under. Pass `null` to remove path from URL params when outside of an organization data context.
 * @returns {string} route path
 */
export const importCsvProjectRequirementsManagementRequirementsPath = /*#__PURE__*/ (projectFullPath, ...args) => {
  const _importCsvOrganizationNamespaceProjectRequirementsManagementRequirementsPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"namespace_id":{"r":true},"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"requirements_management"],[2,[7,"/"],[2,[6,"requirements"],[2,[7,"/"],[2,[6,"import_csv"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]);
  const _importCsvNamespaceProjectRequirementsManagementRequirementsPath = /*#__PURE__*/ __jsr.r({"namespace_id":{"r":true},"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"requirements_management"],[2,[7,"/"],[2,[6,"requirements"],[2,[7,"/"],[2,[6,"import_csv"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

  const { namespacePath, projectPath } = splitProjectFullPath(projectFullPath);
  const { organizationPath, routeArgs } = resolveOrganizationScope(args);

  if (organizationPath) {
    return _importCsvOrganizationNamespaceProjectRequirementsManagementRequirementsPath(organizationPath, namespacePath, projectPath, ...routeArgs);
  }

  return _importCsvNamespaceProjectRequirementsManagementRequirementsPath(namespacePath, projectPath, ...routeArgs);
};

/**
 * Generates the Rails route:
 *
 * - href: `/:project_full_path/-/requirements_management/requirements/import_csv/authorize(.:format)`
 * - Path helper: `import_csv_authorize_project_requirements_management_requirements_path`
 * - URL helper: `import_csv_authorize_project_requirements_management_requirements_url`
 * - controller#action: `projects/requirements_management/requirements#authorize`
 *
 * @param {string} projectFullPath
 * @param {object | undefined} options
 * @param {string | null | undefined} options.organizationPath Path of organization to nest under. Pass `null` to remove path from URL params when outside of an organization data context.
 * @returns {string} route path
 */
export const importCsvAuthorizeProjectRequirementsManagementRequirementsPath = /*#__PURE__*/ (projectFullPath, ...args) => {
  const _importCsvAuthorizeOrganizationNamespaceProjectRequirementsManagementRequirementsPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"namespace_id":{"r":true},"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"requirements_management"],[2,[7,"/"],[2,[6,"requirements"],[2,[7,"/"],[2,[6,"import_csv"],[2,[7,"/"],[2,[6,"authorize"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]]]);
  const _importCsvAuthorizeNamespaceProjectRequirementsManagementRequirementsPath = /*#__PURE__*/ __jsr.r({"namespace_id":{"r":true},"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"requirements_management"],[2,[7,"/"],[2,[6,"requirements"],[2,[7,"/"],[2,[6,"import_csv"],[2,[7,"/"],[2,[6,"authorize"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

  const { namespacePath, projectPath } = splitProjectFullPath(projectFullPath);
  const { organizationPath, routeArgs } = resolveOrganizationScope(args);

  if (organizationPath) {
    return _importCsvAuthorizeOrganizationNamespaceProjectRequirementsManagementRequirementsPath(organizationPath, namespacePath, projectPath, ...routeArgs);
  }

  return _importCsvAuthorizeNamespaceProjectRequirementsManagementRequirementsPath(namespacePath, projectPath, ...routeArgs);
};

/**
 * Generates the Rails route:
 *
 * - href: `/:project_full_path/-/requirements_management/requirements(.:format)`
 * - Path helper: `project_requirements_management_requirements_path`
 * - URL helper: `project_requirements_management_requirements_url`
 * - controller#action: `projects/requirements_management/requirements#index`
 *
 * @param {string} projectFullPath
 * @param {object | undefined} options
 * @param {string | null | undefined} options.organizationPath Path of organization to nest under. Pass `null` to remove path from URL params when outside of an organization data context.
 * @returns {string} route path
 */
export const projectRequirementsManagementRequirementsPath = /*#__PURE__*/ (projectFullPath, ...args) => {
  const _organizationNamespaceProjectRequirementsManagementRequirementsPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"namespace_id":{"r":true},"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"requirements_management"],[2,[7,"/"],[2,[6,"requirements"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);
  const _namespaceProjectRequirementsManagementRequirementsPath = /*#__PURE__*/ __jsr.r({"namespace_id":{"r":true},"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"requirements_management"],[2,[7,"/"],[2,[6,"requirements"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

  const { namespacePath, projectPath } = splitProjectFullPath(projectFullPath);
  const { organizationPath, routeArgs } = resolveOrganizationScope(args);

  if (organizationPath) {
    return _organizationNamespaceProjectRequirementsManagementRequirementsPath(organizationPath, namespacePath, projectPath, ...routeArgs);
  }

  return _namespaceProjectRequirementsManagementRequirementsPath(namespacePath, projectPath, ...routeArgs);
};

/**
 * Generates the Rails route:
 *
 * - href: `/:project_full_path/-/automate/governance`
 * - Path helper: `project_automate_governance_path`
 * - URL helper: `project_automate_governance_url`
 * - controller#action: `projects/automate/governance#index`
 *
 * @param {string} projectFullPath
 * @param {object | undefined} options
 * @param {string | null | undefined} options.organizationPath Path of organization to nest under. Pass `null` to remove path from URL params when outside of an organization data context.
 * @returns {string} route path
 */
export const projectAutomateGovernancePath = /*#__PURE__*/ (projectFullPath, ...args) => {
  const _organizationNamespaceProjectAutomateGovernancePath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"namespace_id":{"r":true},"project_id":{"r":true}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"automate"],[2,[7,"/"],[6,"governance"]]]]]]]]]]]]]]);
  const _namespaceProjectAutomateGovernancePath = /*#__PURE__*/ __jsr.r({"namespace_id":{"r":true},"project_id":{"r":true}}, [2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"automate"],[2,[7,"/"],[6,"governance"]]]]]]]]]]);

  const { namespacePath, projectPath } = splitProjectFullPath(projectFullPath);
  const { organizationPath, routeArgs } = resolveOrganizationScope(args);

  if (organizationPath) {
    return _organizationNamespaceProjectAutomateGovernancePath(organizationPath, namespacePath, projectPath, ...routeArgs);
  }

  return _namespaceProjectAutomateGovernancePath(namespacePath, projectPath, ...routeArgs);
};

/**
 * Generates the Rails route:
 *
 * - href: `/:project_full_path/-/automate(/*vueroute)`
 * - Path helper: `project_automate_path`
 * - URL helper: `project_automate_url`
 * - controller#action: `projects/duo_agents_platform#show`
 *
 * @param {string} projectFullPath
 * @param {object | undefined} options
 * @param {string | null | undefined} options.organizationPath Path of organization to nest under. Pass `null` to remove path from URL params when outside of an organization data context.
 * @returns {string} route path
 */
export const projectAutomatePath = /*#__PURE__*/ (projectFullPath, ...args) => {
  const _organizationNamespaceProjectAutomatePath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"namespace_id":{"r":true},"project_id":{"r":true},"vueroute":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"automate"],[1,[2,[7,"/"],[5,[3,"vueroute"]]]]]]]]]]]]]]]]);
  const _namespaceProjectAutomatePath = /*#__PURE__*/ __jsr.r({"namespace_id":{"r":true},"project_id":{"r":true},"vueroute":{}}, [2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"automate"],[1,[2,[7,"/"],[5,[3,"vueroute"]]]]]]]]]]]]);

  const { namespacePath, projectPath } = splitProjectFullPath(projectFullPath);
  const { organizationPath, routeArgs } = resolveOrganizationScope(args);

  if (organizationPath) {
    return _organizationNamespaceProjectAutomatePath(organizationPath, namespacePath, projectPath, ...routeArgs);
  }

  return _namespaceProjectAutomatePath(namespacePath, projectPath, ...routeArgs);
};

/**
 * Generates the Rails route:
 *
 * - href: `/:project_full_path/-/automate/agent-sessions`
 * - Path helper: `project_automate_agent_sessions_path`
 * - URL helper: `project_automate_agent_sessions_url`
 * - controller#action: `projects/duo_agents_platform#show`
 *
 * @param {string} projectFullPath
 * @param {object | undefined} options
 * @param {string | null | undefined} options.organizationPath Path of organization to nest under. Pass `null` to remove path from URL params when outside of an organization data context.
 * @returns {string} route path
 */
export const projectAutomateAgentSessionsPath = /*#__PURE__*/ (projectFullPath, ...args) => {
  const _organizationNamespaceProjectAutomateAgentSessionsPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"namespace_id":{"r":true},"project_id":{"r":true}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"automate"],[2,[7,"/"],[6,"agent-sessions"]]]]]]]]]]]]]]);
  const _namespaceProjectAutomateAgentSessionsPath = /*#__PURE__*/ __jsr.r({"namespace_id":{"r":true},"project_id":{"r":true}}, [2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"automate"],[2,[7,"/"],[6,"agent-sessions"]]]]]]]]]]);

  const { namespacePath, projectPath } = splitProjectFullPath(projectFullPath);
  const { organizationPath, routeArgs } = resolveOrganizationScope(args);

  if (organizationPath) {
    return _organizationNamespaceProjectAutomateAgentSessionsPath(organizationPath, namespacePath, projectPath, ...routeArgs);
  }

  return _namespaceProjectAutomateAgentSessionsPath(namespacePath, projectPath, ...routeArgs);
};

/**
 * Generates the Rails route:
 *
 * - href: `/:project_full_path/-/automate/agent-sessions/:id`
 * - Path helper: `project_automate_agent_session_path`
 * - URL helper: `project_automate_agent_session_url`
 * - controller#action: `projects/duo_agents_platform#show`
 *
 * @param {string} projectFullPath
 * @param {any} id
 * @param {object | undefined} options
 * @param {string | null | undefined} options.organizationPath Path of organization to nest under. Pass `null` to remove path from URL params when outside of an organization data context.
 * @returns {string} route path
 */
export const projectAutomateAgentSessionPath = /*#__PURE__*/ (projectFullPath, ...args) => {
  const _organizationNamespaceProjectAutomateAgentSessionPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"namespace_id":{"r":true},"project_id":{"r":true},"id":{"r":true}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"automate"],[2,[7,"/"],[2,[6,"agent-sessions"],[2,[7,"/"],[3,"id"]]]]]]]]]]]]]]]]);
  const _namespaceProjectAutomateAgentSessionPath = /*#__PURE__*/ __jsr.r({"namespace_id":{"r":true},"project_id":{"r":true},"id":{"r":true}}, [2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"automate"],[2,[7,"/"],[2,[6,"agent-sessions"],[2,[7,"/"],[3,"id"]]]]]]]]]]]]);

  const { namespacePath, projectPath } = splitProjectFullPath(projectFullPath);
  const { organizationPath, routeArgs } = resolveOrganizationScope(args);

  if (organizationPath) {
    return _organizationNamespaceProjectAutomateAgentSessionPath(organizationPath, namespacePath, projectPath, ...routeArgs);
  }

  return _namespaceProjectAutomateAgentSessionPath(namespacePath, projectPath, ...routeArgs);
};

/**
 * Generates the Rails route:
 *
 * - href: `/:project_full_path/-/automate/agents`
 * - Path helper: `project_automate_agents_path`
 * - URL helper: `project_automate_agents_url`
 * - controller#action: `projects/duo_agents_platform#show`
 *
 * @param {string} projectFullPath
 * @param {object | undefined} options
 * @param {string | null | undefined} options.organizationPath Path of organization to nest under. Pass `null` to remove path from URL params when outside of an organization data context.
 * @returns {string} route path
 */
export const projectAutomateAgentsPath = /*#__PURE__*/ (projectFullPath, ...args) => {
  const _organizationNamespaceProjectAutomateAgentsPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"namespace_id":{"r":true},"project_id":{"r":true}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"automate"],[2,[7,"/"],[6,"agents"]]]]]]]]]]]]]]);
  const _namespaceProjectAutomateAgentsPath = /*#__PURE__*/ __jsr.r({"namespace_id":{"r":true},"project_id":{"r":true}}, [2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"automate"],[2,[7,"/"],[6,"agents"]]]]]]]]]]);

  const { namespacePath, projectPath } = splitProjectFullPath(projectFullPath);
  const { organizationPath, routeArgs } = resolveOrganizationScope(args);

  if (organizationPath) {
    return _organizationNamespaceProjectAutomateAgentsPath(organizationPath, namespacePath, projectPath, ...routeArgs);
  }

  return _namespaceProjectAutomateAgentsPath(namespacePath, projectPath, ...routeArgs);
};

/**
 * Generates the Rails route:
 *
 * - href: `/:project_full_path/-/automate/agents/:id`
 * - Path helper: `project_automate_agent_path`
 * - URL helper: `project_automate_agent_url`
 * - controller#action: `projects/duo_agents_platform#show`
 *
 * @param {string} projectFullPath
 * @param {any} id
 * @param {object | undefined} options
 * @param {string | null | undefined} options.organizationPath Path of organization to nest under. Pass `null` to remove path from URL params when outside of an organization data context.
 * @returns {string} route path
 */
export const projectAutomateAgentPath = /*#__PURE__*/ (projectFullPath, ...args) => {
  const _organizationNamespaceProjectAutomateAgentPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"namespace_id":{"r":true},"project_id":{"r":true},"id":{"r":true}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"automate"],[2,[7,"/"],[2,[6,"agents"],[2,[7,"/"],[3,"id"]]]]]]]]]]]]]]]]);
  const _namespaceProjectAutomateAgentPath = /*#__PURE__*/ __jsr.r({"namespace_id":{"r":true},"project_id":{"r":true},"id":{"r":true}}, [2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"automate"],[2,[7,"/"],[2,[6,"agents"],[2,[7,"/"],[3,"id"]]]]]]]]]]]]);

  const { namespacePath, projectPath } = splitProjectFullPath(projectFullPath);
  const { organizationPath, routeArgs } = resolveOrganizationScope(args);

  if (organizationPath) {
    return _organizationNamespaceProjectAutomateAgentPath(organizationPath, namespacePath, projectPath, ...routeArgs);
  }

  return _namespaceProjectAutomateAgentPath(namespacePath, projectPath, ...routeArgs);
};

/**
 * Generates the Rails route:
 *
 * - href: `/:project_full_path/-/automate/triggers`
 * - Path helper: `project_automate_flow_triggers_path`
 * - URL helper: `project_automate_flow_triggers_url`
 * - controller#action: `projects/duo_agents_platform#show`
 *
 * @param {string} projectFullPath
 * @param {object | undefined} options
 * @param {string | null | undefined} options.organizationPath Path of organization to nest under. Pass `null` to remove path from URL params when outside of an organization data context.
 * @returns {string} route path
 */
export const projectAutomateFlowTriggersPath = /*#__PURE__*/ (projectFullPath, ...args) => {
  const _organizationNamespaceProjectAutomateFlowTriggersPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"namespace_id":{"r":true},"project_id":{"r":true}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"automate"],[2,[7,"/"],[6,"triggers"]]]]]]]]]]]]]]);
  const _namespaceProjectAutomateFlowTriggersPath = /*#__PURE__*/ __jsr.r({"namespace_id":{"r":true},"project_id":{"r":true}}, [2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"automate"],[2,[7,"/"],[6,"triggers"]]]]]]]]]]);

  const { namespacePath, projectPath } = splitProjectFullPath(projectFullPath);
  const { organizationPath, routeArgs } = resolveOrganizationScope(args);

  if (organizationPath) {
    return _organizationNamespaceProjectAutomateFlowTriggersPath(organizationPath, namespacePath, projectPath, ...routeArgs);
  }

  return _namespaceProjectAutomateFlowTriggersPath(namespacePath, projectPath, ...routeArgs);
};

/**
 * Generates the Rails route:
 *
 * - href: `/:project_full_path/-/automate/flows`
 * - Path helper: `project_automate_flows_path`
 * - URL helper: `project_automate_flows_url`
 * - controller#action: `projects/duo_agents_platform#show`
 *
 * @param {string} projectFullPath
 * @param {object | undefined} options
 * @param {string | null | undefined} options.organizationPath Path of organization to nest under. Pass `null` to remove path from URL params when outside of an organization data context.
 * @returns {string} route path
 */
export const projectAutomateFlowsPath = /*#__PURE__*/ (projectFullPath, ...args) => {
  const _organizationNamespaceProjectAutomateFlowsPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"namespace_id":{"r":true},"project_id":{"r":true}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"automate"],[2,[7,"/"],[6,"flows"]]]]]]]]]]]]]]);
  const _namespaceProjectAutomateFlowsPath = /*#__PURE__*/ __jsr.r({"namespace_id":{"r":true},"project_id":{"r":true}}, [2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"automate"],[2,[7,"/"],[6,"flows"]]]]]]]]]]);

  const { namespacePath, projectPath } = splitProjectFullPath(projectFullPath);
  const { organizationPath, routeArgs } = resolveOrganizationScope(args);

  if (organizationPath) {
    return _organizationNamespaceProjectAutomateFlowsPath(organizationPath, namespacePath, projectPath, ...routeArgs);
  }

  return _namespaceProjectAutomateFlowsPath(namespacePath, projectPath, ...routeArgs);
};

/**
 * Generates the Rails route:
 *
 * - href: `/:project_full_path/-/automate/flows/:id`
 * - Path helper: `project_automate_flow_path`
 * - URL helper: `project_automate_flow_url`
 * - controller#action: `projects/duo_agents_platform#show`
 *
 * @param {string} projectFullPath
 * @param {any} id
 * @param {object | undefined} options
 * @param {string | null | undefined} options.organizationPath Path of organization to nest under. Pass `null` to remove path from URL params when outside of an organization data context.
 * @returns {string} route path
 */
export const projectAutomateFlowPath = /*#__PURE__*/ (projectFullPath, ...args) => {
  const _organizationNamespaceProjectAutomateFlowPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"namespace_id":{"r":true},"project_id":{"r":true},"id":{"r":true}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"automate"],[2,[7,"/"],[2,[6,"flows"],[2,[7,"/"],[3,"id"]]]]]]]]]]]]]]]]);
  const _namespaceProjectAutomateFlowPath = /*#__PURE__*/ __jsr.r({"namespace_id":{"r":true},"project_id":{"r":true},"id":{"r":true}}, [2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"automate"],[2,[7,"/"],[2,[6,"flows"],[2,[7,"/"],[3,"id"]]]]]]]]]]]]);

  const { namespacePath, projectPath } = splitProjectFullPath(projectFullPath);
  const { organizationPath, routeArgs } = resolveOrganizationScope(args);

  if (organizationPath) {
    return _organizationNamespaceProjectAutomateFlowPath(organizationPath, namespacePath, projectPath, ...routeArgs);
  }

  return _namespaceProjectAutomateFlowPath(namespacePath, projectPath, ...routeArgs);
};

/**
 * Generates the Rails route:
 *
 * - href: `/:project_full_path/-/automate/mcp-servers`
 * - Path helper: `project_automate_mcp_servers_path`
 * - URL helper: `project_automate_mcp_servers_url`
 * - controller#action: `projects/duo_agents_platform#show`
 *
 * @param {string} projectFullPath
 * @param {object | undefined} options
 * @param {string | null | undefined} options.organizationPath Path of organization to nest under. Pass `null` to remove path from URL params when outside of an organization data context.
 * @returns {string} route path
 */
export const projectAutomateMcpServersPath = /*#__PURE__*/ (projectFullPath, ...args) => {
  const _organizationNamespaceProjectAutomateMcpServersPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"namespace_id":{"r":true},"project_id":{"r":true}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"automate"],[2,[7,"/"],[6,"mcp-servers"]]]]]]]]]]]]]]);
  const _namespaceProjectAutomateMcpServersPath = /*#__PURE__*/ __jsr.r({"namespace_id":{"r":true},"project_id":{"r":true}}, [2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"automate"],[2,[7,"/"],[6,"mcp-servers"]]]]]]]]]]);

  const { namespacePath, projectPath } = splitProjectFullPath(projectFullPath);
  const { organizationPath, routeArgs } = resolveOrganizationScope(args);

  if (organizationPath) {
    return _organizationNamespaceProjectAutomateMcpServersPath(organizationPath, namespacePath, projectPath, ...routeArgs);
  }

  return _namespaceProjectAutomateMcpServersPath(namespacePath, projectPath, ...routeArgs);
};

/**
 * Generates the Rails route:
 *
 * - href: `/:project_full_path/-/duo_otel_workflows(.:format)`
 * - Path helper: `project_duo_otel_workflows_path`
 * - URL helper: `project_duo_otel_workflows_url`
 * - controller#action: `projects/duo_otel_workflows#create`
 *
 * @param {string} projectFullPath
 * @param {object | undefined} options
 * @param {string | null | undefined} options.organizationPath Path of organization to nest under. Pass `null` to remove path from URL params when outside of an organization data context.
 * @returns {string} route path
 */
export const projectDuoOtelWorkflowsPath = /*#__PURE__*/ (projectFullPath, ...args) => {
  const _organizationNamespaceProjectDuoOtelWorkflowsPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"namespace_id":{"r":true},"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"duo_otel_workflows"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);
  const _namespaceProjectDuoOtelWorkflowsPath = /*#__PURE__*/ __jsr.r({"namespace_id":{"r":true},"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"duo_otel_workflows"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

  const { namespacePath, projectPath } = splitProjectFullPath(projectFullPath);
  const { organizationPath, routeArgs } = resolveOrganizationScope(args);

  if (organizationPath) {
    return _organizationNamespaceProjectDuoOtelWorkflowsPath(organizationPath, namespacePath, projectPath, ...routeArgs);
  }

  return _namespaceProjectDuoOtelWorkflowsPath(namespacePath, projectPath, ...routeArgs);
};

/**
 * Generates the Rails route:
 *
 * - href: `/:project_full_path/-/quality/test_cases(.:format)`
 * - Path helper: `project_quality_test_cases_path`
 * - URL helper: `project_quality_test_cases_url`
 * - controller#action: `projects/quality/test_cases#index`
 *
 * @param {string} projectFullPath
 * @param {object | undefined} options
 * @param {string | null | undefined} options.organizationPath Path of organization to nest under. Pass `null` to remove path from URL params when outside of an organization data context.
 * @returns {string} route path
 */
export const projectQualityTestCasesPath = /*#__PURE__*/ (projectFullPath, ...args) => {
  const _organizationNamespaceProjectQualityTestCasesPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"namespace_id":{"r":true},"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"quality"],[2,[7,"/"],[2,[6,"test_cases"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);
  const _namespaceProjectQualityTestCasesPath = /*#__PURE__*/ __jsr.r({"namespace_id":{"r":true},"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"quality"],[2,[7,"/"],[2,[6,"test_cases"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

  const { namespacePath, projectPath } = splitProjectFullPath(projectFullPath);
  const { organizationPath, routeArgs } = resolveOrganizationScope(args);

  if (organizationPath) {
    return _organizationNamespaceProjectQualityTestCasesPath(organizationPath, namespacePath, projectPath, ...routeArgs);
  }

  return _namespaceProjectQualityTestCasesPath(namespacePath, projectPath, ...routeArgs);
};

/**
 * Generates the Rails route:
 *
 * - href: `/:project_full_path/-/quality/test_cases/new(.:format)`
 * - Path helper: `new_project_quality_test_case_path`
 * - URL helper: `new_project_quality_test_case_url`
 * - controller#action: `projects/quality/test_cases#new`
 *
 * @param {string} projectFullPath
 * @param {object | undefined} options
 * @param {string | null | undefined} options.organizationPath Path of organization to nest under. Pass `null` to remove path from URL params when outside of an organization data context.
 * @returns {string} route path
 */
export const newProjectQualityTestCasePath = /*#__PURE__*/ (projectFullPath, ...args) => {
  const _newOrganizationNamespaceProjectQualityTestCasePath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"namespace_id":{"r":true},"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"quality"],[2,[7,"/"],[2,[6,"test_cases"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]);
  const _newNamespaceProjectQualityTestCasePath = /*#__PURE__*/ __jsr.r({"namespace_id":{"r":true},"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"quality"],[2,[7,"/"],[2,[6,"test_cases"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

  const { namespacePath, projectPath } = splitProjectFullPath(projectFullPath);
  const { organizationPath, routeArgs } = resolveOrganizationScope(args);

  if (organizationPath) {
    return _newOrganizationNamespaceProjectQualityTestCasePath(organizationPath, namespacePath, projectPath, ...routeArgs);
  }

  return _newNamespaceProjectQualityTestCasePath(namespacePath, projectPath, ...routeArgs);
};

/**
 * Generates the Rails route:
 *
 * - href: `/:project_full_path/-/quality/test_cases/:id(.:format)`
 * - Path helper: `project_quality_test_case_path`
 * - URL helper: `project_quality_test_case_url`
 * - controller#action: `projects/quality/test_cases#show`
 *
 * @param {string} projectFullPath
 * @param {any} id
 * @param {object | undefined} options
 * @param {string | null | undefined} options.organizationPath Path of organization to nest under. Pass `null` to remove path from URL params when outside of an organization data context.
 * @returns {string} route path
 */
export const projectQualityTestCasePath = /*#__PURE__*/ (projectFullPath, ...args) => {
  const _organizationNamespaceProjectQualityTestCasePath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"namespace_id":{"r":true},"project_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"quality"],[2,[7,"/"],[2,[6,"test_cases"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]);
  const _namespaceProjectQualityTestCasePath = /*#__PURE__*/ __jsr.r({"namespace_id":{"r":true},"project_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"quality"],[2,[7,"/"],[2,[6,"test_cases"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

  const { namespacePath, projectPath } = splitProjectFullPath(projectFullPath);
  const { organizationPath, routeArgs } = resolveOrganizationScope(args);

  if (organizationPath) {
    return _organizationNamespaceProjectQualityTestCasePath(organizationPath, namespacePath, projectPath, ...routeArgs);
  }

  return _namespaceProjectQualityTestCasePath(namespacePath, projectPath, ...routeArgs);
};

/**
 * Generates the Rails route:
 *
 * - href: `/:project_full_path/-/autocomplete_sources/epics(.:format)`
 * - Path helper: `epics_project_autocomplete_sources_path`
 * - URL helper: `epics_project_autocomplete_sources_url`
 * - controller#action: `projects/autocomplete_sources#epics`
 *
 * @param {string} projectFullPath
 * @param {object | undefined} options
 * @param {string | null | undefined} options.organizationPath Path of organization to nest under. Pass `null` to remove path from URL params when outside of an organization data context.
 * @returns {string} route path
 */
export const epicsProjectAutocompleteSourcesPath = /*#__PURE__*/ (projectFullPath, ...args) => {
  const _epicsOrganizationNamespaceProjectAutocompleteSourcesPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"namespace_id":{"r":true},"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"autocomplete_sources"],[2,[7,"/"],[2,[6,"epics"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);
  const _epicsNamespaceProjectAutocompleteSourcesPath = /*#__PURE__*/ __jsr.r({"namespace_id":{"r":true},"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"autocomplete_sources"],[2,[7,"/"],[2,[6,"epics"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

  const { namespacePath, projectPath } = splitProjectFullPath(projectFullPath);
  const { organizationPath, routeArgs } = resolveOrganizationScope(args);

  if (organizationPath) {
    return _epicsOrganizationNamespaceProjectAutocompleteSourcesPath(organizationPath, namespacePath, projectPath, ...routeArgs);
  }

  return _epicsNamespaceProjectAutocompleteSourcesPath(namespacePath, projectPath, ...routeArgs);
};

/**
 * Generates the Rails route:
 *
 * - href: `/:project_full_path/-/autocomplete_sources/iterations(.:format)`
 * - Path helper: `iterations_project_autocomplete_sources_path`
 * - URL helper: `iterations_project_autocomplete_sources_url`
 * - controller#action: `projects/autocomplete_sources#iterations`
 *
 * @param {string} projectFullPath
 * @param {object | undefined} options
 * @param {string | null | undefined} options.organizationPath Path of organization to nest under. Pass `null` to remove path from URL params when outside of an organization data context.
 * @returns {string} route path
 */
export const iterationsProjectAutocompleteSourcesPath = /*#__PURE__*/ (projectFullPath, ...args) => {
  const _iterationsOrganizationNamespaceProjectAutocompleteSourcesPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"namespace_id":{"r":true},"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"autocomplete_sources"],[2,[7,"/"],[2,[6,"iterations"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);
  const _iterationsNamespaceProjectAutocompleteSourcesPath = /*#__PURE__*/ __jsr.r({"namespace_id":{"r":true},"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"autocomplete_sources"],[2,[7,"/"],[2,[6,"iterations"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

  const { namespacePath, projectPath } = splitProjectFullPath(projectFullPath);
  const { organizationPath, routeArgs } = resolveOrganizationScope(args);

  if (organizationPath) {
    return _iterationsOrganizationNamespaceProjectAutocompleteSourcesPath(organizationPath, namespacePath, projectPath, ...routeArgs);
  }

  return _iterationsNamespaceProjectAutocompleteSourcesPath(namespacePath, projectPath, ...routeArgs);
};

/**
 * Generates the Rails route:
 *
 * - href: `/:project_full_path/-/autocomplete_sources/vulnerabilities(.:format)`
 * - Path helper: `vulnerabilities_project_autocomplete_sources_path`
 * - URL helper: `vulnerabilities_project_autocomplete_sources_url`
 * - controller#action: `projects/autocomplete_sources#vulnerabilities`
 *
 * @param {string} projectFullPath
 * @param {object | undefined} options
 * @param {string | null | undefined} options.organizationPath Path of organization to nest under. Pass `null` to remove path from URL params when outside of an organization data context.
 * @returns {string} route path
 */
export const vulnerabilitiesProjectAutocompleteSourcesPath = /*#__PURE__*/ (projectFullPath, ...args) => {
  const _vulnerabilitiesOrganizationNamespaceProjectAutocompleteSourcesPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"namespace_id":{"r":true},"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"autocomplete_sources"],[2,[7,"/"],[2,[6,"vulnerabilities"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);
  const _vulnerabilitiesNamespaceProjectAutocompleteSourcesPath = /*#__PURE__*/ __jsr.r({"namespace_id":{"r":true},"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"autocomplete_sources"],[2,[7,"/"],[2,[6,"vulnerabilities"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

  const { namespacePath, projectPath } = splitProjectFullPath(projectFullPath);
  const { organizationPath, routeArgs } = resolveOrganizationScope(args);

  if (organizationPath) {
    return _vulnerabilitiesOrganizationNamespaceProjectAutocompleteSourcesPath(organizationPath, namespacePath, projectPath, ...routeArgs);
  }

  return _vulnerabilitiesNamespaceProjectAutocompleteSourcesPath(namespacePath, projectPath, ...routeArgs);
};

/**
 * Generates the Rails route:
 *
 * - href: `/:project_full_path/-/target_branch_rules(.:format)`
 * - Path helper: `project_target_branch_rules_path`
 * - URL helper: `project_target_branch_rules_url`
 * - controller#action: `projects/target_branch_rules#index`
 *
 * @param {string} projectFullPath
 * @param {object | undefined} options
 * @param {string | null | undefined} options.organizationPath Path of organization to nest under. Pass `null` to remove path from URL params when outside of an organization data context.
 * @returns {string} route path
 */
export const projectTargetBranchRulesPath = /*#__PURE__*/ (projectFullPath, ...args) => {
  const _organizationNamespaceProjectTargetBranchRulesPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"namespace_id":{"r":true},"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"target_branch_rules"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);
  const _namespaceProjectTargetBranchRulesPath = /*#__PURE__*/ __jsr.r({"namespace_id":{"r":true},"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"target_branch_rules"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

  const { namespacePath, projectPath } = splitProjectFullPath(projectFullPath);
  const { organizationPath, routeArgs } = resolveOrganizationScope(args);

  if (organizationPath) {
    return _organizationNamespaceProjectTargetBranchRulesPath(organizationPath, namespacePath, projectPath, ...routeArgs);
  }

  return _namespaceProjectTargetBranchRulesPath(namespacePath, projectPath, ...routeArgs);
};

/**
 * Generates the Rails route:
 *
 * - href: `/:project_full_path/-/target_branch_rules/:id(.:format)`
 * - Path helper: `project_target_branch_rule_path`
 * - URL helper: `project_target_branch_rule_url`
 * - controller#action: `projects/target_branch_rules#destroy`
 *
 * @param {string} projectFullPath
 * @param {any} id
 * @param {object | undefined} options
 * @param {string | null | undefined} options.organizationPath Path of organization to nest under. Pass `null` to remove path from URL params when outside of an organization data context.
 * @returns {string} route path
 */
export const projectTargetBranchRulePath = /*#__PURE__*/ (projectFullPath, ...args) => {
  const _organizationNamespaceProjectTargetBranchRulePath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"namespace_id":{"r":true},"project_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"target_branch_rules"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);
  const _namespaceProjectTargetBranchRulePath = /*#__PURE__*/ __jsr.r({"namespace_id":{"r":true},"project_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"target_branch_rules"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

  const { namespacePath, projectPath } = splitProjectFullPath(projectFullPath);
  const { organizationPath, routeArgs } = resolveOrganizationScope(args);

  if (organizationPath) {
    return _organizationNamespaceProjectTargetBranchRulePath(organizationPath, namespacePath, projectPath, ...routeArgs);
  }

  return _namespaceProjectTargetBranchRulePath(namespacePath, projectPath, ...routeArgs);
};

/**
 * Generates the Rails route:
 *
 * - href: `/:project_full_path/-/comment_templates(.:format)`
 * - Path helper: `project_comment_templates_path`
 * - URL helper: `project_comment_templates_url`
 * - controller#action: `projects/comment_templates#index`
 *
 * @param {string} projectFullPath
 * @param {object | undefined} options
 * @param {string | null | undefined} options.organizationPath Path of organization to nest under. Pass `null` to remove path from URL params when outside of an organization data context.
 * @returns {string} route path
 */
export const projectCommentTemplatesPath = /*#__PURE__*/ (projectFullPath, ...args) => {
  const _organizationNamespaceProjectCommentTemplatesPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"namespace_id":{"r":true},"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"comment_templates"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);
  const _namespaceProjectCommentTemplatesPath = /*#__PURE__*/ __jsr.r({"namespace_id":{"r":true},"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"comment_templates"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

  const { namespacePath, projectPath } = splitProjectFullPath(projectFullPath);
  const { organizationPath, routeArgs } = resolveOrganizationScope(args);

  if (organizationPath) {
    return _organizationNamespaceProjectCommentTemplatesPath(organizationPath, namespacePath, projectPath, ...routeArgs);
  }

  return _namespaceProjectCommentTemplatesPath(namespacePath, projectPath, ...routeArgs);
};

/**
 * Generates the Rails route:
 *
 * - href: `/:project_full_path/-/comment_templates/:id(.:format)`
 * - Path helper: `project_comment_template_path`
 * - URL helper: `project_comment_template_url`
 * - controller#action: `projects/comment_templates#index`
 *
 * @param {string} projectFullPath
 * @param {any} id
 * @param {object | undefined} options
 * @param {string | null | undefined} options.organizationPath Path of organization to nest under. Pass `null` to remove path from URL params when outside of an organization data context.
 * @returns {string} route path
 */
export const projectCommentTemplatePath = /*#__PURE__*/ (projectFullPath, ...args) => {
  const _organizationNamespaceProjectCommentTemplatePath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"namespace_id":{"r":true},"project_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"comment_templates"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);
  const _namespaceProjectCommentTemplatePath = /*#__PURE__*/ __jsr.r({"namespace_id":{"r":true},"project_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"comment_templates"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

  const { namespacePath, projectPath } = splitProjectFullPath(projectFullPath);
  const { organizationPath, routeArgs } = resolveOrganizationScope(args);

  if (organizationPath) {
    return _organizationNamespaceProjectCommentTemplatePath(organizationPath, namespacePath, projectPath, ...routeArgs);
  }

  return _namespaceProjectCommentTemplatePath(namespacePath, projectPath, ...routeArgs);
};

/**
 * Generates the Rails route:
 *
 * - href: `/:project_full_path/-/automations(.:format)`
 * - Path helper: `project_automations_path`
 * - URL helper: `project_automations_url`
 * - controller#action: `projects/automations#index`
 *
 * @param {string} projectFullPath
 * @param {object | undefined} options
 * @param {string | null | undefined} options.organizationPath Path of organization to nest under. Pass `null` to remove path from URL params when outside of an organization data context.
 * @returns {string} route path
 */
export const projectAutomationsPath = /*#__PURE__*/ (projectFullPath, ...args) => {
  const _organizationNamespaceProjectAutomationsPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"namespace_id":{"r":true},"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"automations"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);
  const _namespaceProjectAutomationsPath = /*#__PURE__*/ __jsr.r({"namespace_id":{"r":true},"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"automations"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

  const { namespacePath, projectPath } = splitProjectFullPath(projectFullPath);
  const { organizationPath, routeArgs } = resolveOrganizationScope(args);

  if (organizationPath) {
    return _organizationNamespaceProjectAutomationsPath(organizationPath, namespacePath, projectPath, ...routeArgs);
  }

  return _namespaceProjectAutomationsPath(namespacePath, projectPath, ...routeArgs);
};

/**
 * Generates the Rails route:
 *
 * - href: `/:project_full_path/-/subscriptions(.:format)`
 * - Path helper: `project_subscriptions_path`
 * - URL helper: `project_subscriptions_url`
 * - controller#action: `projects/subscriptions#create`
 *
 * @param {string} projectFullPath
 * @param {object | undefined} options
 * @param {string | null | undefined} options.organizationPath Path of organization to nest under. Pass `null` to remove path from URL params when outside of an organization data context.
 * @returns {string} route path
 */
export const projectSubscriptionsPath = /*#__PURE__*/ (projectFullPath, ...args) => {
  const _organizationNamespaceProjectSubscriptionsPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"namespace_id":{"r":true},"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"subscriptions"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);
  const _namespaceProjectSubscriptionsPath = /*#__PURE__*/ __jsr.r({"namespace_id":{"r":true},"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"subscriptions"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

  const { namespacePath, projectPath } = splitProjectFullPath(projectFullPath);
  const { organizationPath, routeArgs } = resolveOrganizationScope(args);

  if (organizationPath) {
    return _organizationNamespaceProjectSubscriptionsPath(organizationPath, namespacePath, projectPath, ...routeArgs);
  }

  return _namespaceProjectSubscriptionsPath(namespacePath, projectPath, ...routeArgs);
};

/**
 * Generates the Rails route:
 *
 * - href: `/:project_full_path/-/subscriptions/:id(.:format)`
 * - Path helper: `project_subscription_path`
 * - URL helper: `project_subscription_url`
 * - controller#action: `projects/subscriptions#destroy`
 *
 * @param {string} projectFullPath
 * @param {any} id
 * @param {object | undefined} options
 * @param {string | null | undefined} options.organizationPath Path of organization to nest under. Pass `null` to remove path from URL params when outside of an organization data context.
 * @returns {string} route path
 */
export const projectSubscriptionPath = /*#__PURE__*/ (projectFullPath, ...args) => {
  const _organizationNamespaceProjectSubscriptionPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"namespace_id":{"r":true},"project_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"subscriptions"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);
  const _namespaceProjectSubscriptionPath = /*#__PURE__*/ __jsr.r({"namespace_id":{"r":true},"project_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"subscriptions"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

  const { namespacePath, projectPath } = splitProjectFullPath(projectFullPath);
  const { organizationPath, routeArgs } = resolveOrganizationScope(args);

  if (organizationPath) {
    return _organizationNamespaceProjectSubscriptionPath(organizationPath, namespacePath, projectPath, ...routeArgs);
  }

  return _namespaceProjectSubscriptionPath(namespacePath, projectPath, ...routeArgs);
};

/**
 * Generates the Rails route:
 *
 * - href: `/:project_full_path/-/get_started/end_tutorial(.:format)`
 * - Path helper: `end_tutorial_project_get_started_path`
 * - URL helper: `end_tutorial_project_get_started_url`
 * - controller#action: `projects/get_started#end_tutorial`
 *
 * @param {string} projectFullPath
 * @param {object | undefined} options
 * @param {string | null | undefined} options.organizationPath Path of organization to nest under. Pass `null` to remove path from URL params when outside of an organization data context.
 * @returns {string} route path
 */
export const endTutorialProjectGetStartedPath = /*#__PURE__*/ (projectFullPath, ...args) => {
  const _endTutorialOrganizationNamespaceProjectGetStartedPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"namespace_id":{"r":true},"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"get_started"],[2,[7,"/"],[2,[6,"end_tutorial"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);
  const _endTutorialNamespaceProjectGetStartedPath = /*#__PURE__*/ __jsr.r({"namespace_id":{"r":true},"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"get_started"],[2,[7,"/"],[2,[6,"end_tutorial"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

  const { namespacePath, projectPath } = splitProjectFullPath(projectFullPath);
  const { organizationPath, routeArgs } = resolveOrganizationScope(args);

  if (organizationPath) {
    return _endTutorialOrganizationNamespaceProjectGetStartedPath(organizationPath, namespacePath, projectPath, ...routeArgs);
  }

  return _endTutorialNamespaceProjectGetStartedPath(namespacePath, projectPath, ...routeArgs);
};

/**
 * Generates the Rails route:
 *
 * - href: `/:project_full_path/-/get_started(.:format)`
 * - Path helper: `project_get_started_path`
 * - URL helper: `project_get_started_url`
 * - controller#action: `projects/get_started#show`
 *
 * @param {string} projectFullPath
 * @param {object | undefined} options
 * @param {string | null | undefined} options.organizationPath Path of organization to nest under. Pass `null` to remove path from URL params when outside of an organization data context.
 * @returns {string} route path
 */
export const projectGetStartedPath = /*#__PURE__*/ (projectFullPath, ...args) => {
  const _organizationNamespaceProjectGetStartedPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"namespace_id":{"r":true},"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"get_started"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);
  const _namespaceProjectGetStartedPath = /*#__PURE__*/ __jsr.r({"namespace_id":{"r":true},"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"get_started"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

  const { namespacePath, projectPath } = splitProjectFullPath(projectFullPath);
  const { organizationPath, routeArgs } = resolveOrganizationScope(args);

  if (organizationPath) {
    return _organizationNamespaceProjectGetStartedPath(organizationPath, namespacePath, projectPath, ...routeArgs);
  }

  return _namespaceProjectGetStartedPath(namespacePath, projectPath, ...routeArgs);
};

/**
 * Generates the Rails route:
 *
 * - href: `/:project_full_path/-/learn_gitlab/end_tutorial(.:format)`
 * - Path helper: `end_tutorial_project_learn_gitlab_path`
 * - URL helper: `end_tutorial_project_learn_gitlab_url`
 * - controller#action: `projects/learn_gitlab#end_tutorial`
 *
 * @param {string} projectFullPath
 * @param {object | undefined} options
 * @param {string | null | undefined} options.organizationPath Path of organization to nest under. Pass `null` to remove path from URL params when outside of an organization data context.
 * @returns {string} route path
 */
export const endTutorialProjectLearnGitlabPath = /*#__PURE__*/ (projectFullPath, ...args) => {
  const _endTutorialOrganizationNamespaceProjectLearnGitlabPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"namespace_id":{"r":true},"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"learn_gitlab"],[2,[7,"/"],[2,[6,"end_tutorial"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);
  const _endTutorialNamespaceProjectLearnGitlabPath = /*#__PURE__*/ __jsr.r({"namespace_id":{"r":true},"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"learn_gitlab"],[2,[7,"/"],[2,[6,"end_tutorial"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

  const { namespacePath, projectPath } = splitProjectFullPath(projectFullPath);
  const { organizationPath, routeArgs } = resolveOrganizationScope(args);

  if (organizationPath) {
    return _endTutorialOrganizationNamespaceProjectLearnGitlabPath(organizationPath, namespacePath, projectPath, ...routeArgs);
  }

  return _endTutorialNamespaceProjectLearnGitlabPath(namespacePath, projectPath, ...routeArgs);
};

/**
 * Generates the Rails route:
 *
 * - href: `/:project_full_path/-/learn_gitlab(.:format)`
 * - Path helper: `project_learn_gitlab_path`
 * - URL helper: `project_learn_gitlab_url`
 * - controller#action: `projects/learn_gitlab#show`
 *
 * @param {string} projectFullPath
 * @param {object | undefined} options
 * @param {string | null | undefined} options.organizationPath Path of organization to nest under. Pass `null` to remove path from URL params when outside of an organization data context.
 * @returns {string} route path
 */
export const projectLearnGitlabPath = /*#__PURE__*/ (projectFullPath, ...args) => {
  const _organizationNamespaceProjectLearnGitlabPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"namespace_id":{"r":true},"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"learn_gitlab"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);
  const _namespaceProjectLearnGitlabPath = /*#__PURE__*/ __jsr.r({"namespace_id":{"r":true},"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"learn_gitlab"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

  const { namespacePath, projectPath } = splitProjectFullPath(projectFullPath);
  const { organizationPath, routeArgs } = resolveOrganizationScope(args);

  if (organizationPath) {
    return _organizationNamespaceProjectLearnGitlabPath(organizationPath, namespacePath, projectPath, ...routeArgs);
  }

  return _namespaceProjectLearnGitlabPath(namespacePath, projectPath, ...routeArgs);
};

/**
 * Generates the Rails route:
 *
 * - href: `/:project_full_path/-/protected_environments/search(.:format)`
 * - Path helper: `search_project_protected_environments_path`
 * - URL helper: `search_project_protected_environments_url`
 * - controller#action: `projects/protected_environments#search`
 *
 * @param {string} projectFullPath
 * @param {object | undefined} options
 * @param {string | null | undefined} options.organizationPath Path of organization to nest under. Pass `null` to remove path from URL params when outside of an organization data context.
 * @returns {string} route path
 */
export const searchProjectProtectedEnvironmentsPath = /*#__PURE__*/ (projectFullPath, ...args) => {
  const _searchOrganizationNamespaceProjectProtectedEnvironmentsPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"namespace_id":{"r":true},"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"protected_environments"],[2,[7,"/"],[2,[6,"search"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);
  const _searchNamespaceProjectProtectedEnvironmentsPath = /*#__PURE__*/ __jsr.r({"namespace_id":{"r":true},"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"protected_environments"],[2,[7,"/"],[2,[6,"search"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

  const { namespacePath, projectPath } = splitProjectFullPath(projectFullPath);
  const { organizationPath, routeArgs } = resolveOrganizationScope(args);

  if (organizationPath) {
    return _searchOrganizationNamespaceProjectProtectedEnvironmentsPath(organizationPath, namespacePath, projectPath, ...routeArgs);
  }

  return _searchNamespaceProjectProtectedEnvironmentsPath(namespacePath, projectPath, ...routeArgs);
};

/**
 * Generates the Rails route:
 *
 * - href: `/:project_full_path/-/protected_environments(.:format)`
 * - Path helper: `project_protected_environments_path`
 * - URL helper: `project_protected_environments_url`
 * - controller#action: `projects/protected_environments#create`
 *
 * @param {string} projectFullPath
 * @param {object | undefined} options
 * @param {string | null | undefined} options.organizationPath Path of organization to nest under. Pass `null` to remove path from URL params when outside of an organization data context.
 * @returns {string} route path
 */
export const projectProtectedEnvironmentsPath = /*#__PURE__*/ (projectFullPath, ...args) => {
  const _organizationNamespaceProjectProtectedEnvironmentsPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"namespace_id":{"r":true},"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"protected_environments"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);
  const _namespaceProjectProtectedEnvironmentsPath = /*#__PURE__*/ __jsr.r({"namespace_id":{"r":true},"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"protected_environments"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

  const { namespacePath, projectPath } = splitProjectFullPath(projectFullPath);
  const { organizationPath, routeArgs } = resolveOrganizationScope(args);

  if (organizationPath) {
    return _organizationNamespaceProjectProtectedEnvironmentsPath(organizationPath, namespacePath, projectPath, ...routeArgs);
  }

  return _namespaceProjectProtectedEnvironmentsPath(namespacePath, projectPath, ...routeArgs);
};

/**
 * Generates the Rails route:
 *
 * - href: `/:project_full_path/-/protected_environments/:id(.:format)`
 * - Path helper: `project_protected_environment_path`
 * - URL helper: `project_protected_environment_url`
 * - controller#action: `projects/protected_environments#update`
 *
 * @param {string} projectFullPath
 * @param {any} id
 * @param {object | undefined} options
 * @param {string | null | undefined} options.organizationPath Path of organization to nest under. Pass `null` to remove path from URL params when outside of an organization data context.
 * @returns {string} route path
 */
export const projectProtectedEnvironmentPath = /*#__PURE__*/ (projectFullPath, ...args) => {
  const _organizationNamespaceProjectProtectedEnvironmentPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"namespace_id":{"r":true},"project_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"protected_environments"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);
  const _namespaceProjectProtectedEnvironmentPath = /*#__PURE__*/ __jsr.r({"namespace_id":{"r":true},"project_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"protected_environments"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

  const { namespacePath, projectPath } = splitProjectFullPath(projectFullPath);
  const { organizationPath, routeArgs } = resolveOrganizationScope(args);

  if (organizationPath) {
    return _organizationNamespaceProjectProtectedEnvironmentPath(organizationPath, namespacePath, projectPath, ...routeArgs);
  }

  return _namespaceProjectProtectedEnvironmentPath(namespacePath, projectPath, ...routeArgs);
};

/**
 * Generates the Rails route:
 *
 * - href: `/:project_full_path/-/audit_events(.:format)`
 * - Path helper: `project_audit_events_path`
 * - URL helper: `project_audit_events_url`
 * - controller#action: `projects/audit_events#index`
 *
 * @param {string} projectFullPath
 * @param {object | undefined} options
 * @param {string | null | undefined} options.organizationPath Path of organization to nest under. Pass `null` to remove path from URL params when outside of an organization data context.
 * @returns {string} route path
 */
export const projectAuditEventsPath = /*#__PURE__*/ (projectFullPath, ...args) => {
  const _organizationNamespaceProjectAuditEventsPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"namespace_id":{"r":true},"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"audit_events"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);
  const _namespaceProjectAuditEventsPath = /*#__PURE__*/ __jsr.r({"namespace_id":{"r":true},"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"audit_events"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

  const { namespacePath, projectPath } = splitProjectFullPath(projectFullPath);
  const { organizationPath, routeArgs } = resolveOrganizationScope(args);

  if (organizationPath) {
    return _organizationNamespaceProjectAuditEventsPath(organizationPath, namespacePath, projectPath, ...routeArgs);
  }

  return _namespaceProjectAuditEventsPath(namespacePath, projectPath, ...routeArgs);
};

/**
 * Generates the Rails route:
 *
 * - href: `/:project_full_path/-/security/dashboard(.:format)`
 * - Path helper: `project_security_dashboard_index_path`
 * - URL helper: `project_security_dashboard_index_url`
 * - controller#action: `projects/security/dashboard#index`
 *
 * @param {string} projectFullPath
 * @param {object | undefined} options
 * @param {string | null | undefined} options.organizationPath Path of organization to nest under. Pass `null` to remove path from URL params when outside of an organization data context.
 * @returns {string} route path
 */
export const projectSecurityDashboardIndexPath = /*#__PURE__*/ (projectFullPath, ...args) => {
  const _organizationNamespaceProjectSecurityDashboardIndexPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"namespace_id":{"r":true},"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"security"],[2,[7,"/"],[2,[6,"dashboard"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);
  const _namespaceProjectSecurityDashboardIndexPath = /*#__PURE__*/ __jsr.r({"namespace_id":{"r":true},"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"security"],[2,[7,"/"],[2,[6,"dashboard"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

  const { namespacePath, projectPath } = splitProjectFullPath(projectFullPath);
  const { organizationPath, routeArgs } = resolveOrganizationScope(args);

  if (organizationPath) {
    return _organizationNamespaceProjectSecurityDashboardIndexPath(organizationPath, namespacePath, projectPath, ...routeArgs);
  }

  return _namespaceProjectSecurityDashboardIndexPath(namespacePath, projectPath, ...routeArgs);
};

/**
 * Generates the Rails route:
 *
 * - href: `/:project_full_path/-/security/vulnerability_report(.:format)`
 * - Path helper: `project_security_vulnerability_report_index_path`
 * - URL helper: `project_security_vulnerability_report_index_url`
 * - controller#action: `projects/security/vulnerability_report#index`
 *
 * @param {string} projectFullPath
 * @param {object | undefined} options
 * @param {string | null | undefined} options.organizationPath Path of organization to nest under. Pass `null` to remove path from URL params when outside of an organization data context.
 * @returns {string} route path
 */
export const projectSecurityVulnerabilityReportIndexPath = /*#__PURE__*/ (projectFullPath, ...args) => {
  const _organizationNamespaceProjectSecurityVulnerabilityReportIndexPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"namespace_id":{"r":true},"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"security"],[2,[7,"/"],[2,[6,"vulnerability_report"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);
  const _namespaceProjectSecurityVulnerabilityReportIndexPath = /*#__PURE__*/ __jsr.r({"namespace_id":{"r":true},"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"security"],[2,[7,"/"],[2,[6,"vulnerability_report"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

  const { namespacePath, projectPath } = splitProjectFullPath(projectFullPath);
  const { organizationPath, routeArgs } = resolveOrganizationScope(args);

  if (organizationPath) {
    return _organizationNamespaceProjectSecurityVulnerabilityReportIndexPath(organizationPath, namespacePath, projectPath, ...routeArgs);
  }

  return _namespaceProjectSecurityVulnerabilityReportIndexPath(namespacePath, projectPath, ...routeArgs);
};

/**
 * Generates the Rails route:
 *
 * - href: `/:project_full_path/-/security/compliance_dashboard(/*vueroute)(.:format)`
 * - Path helper: `project_security_compliance_dashboard_path`
 * - URL helper: `project_security_compliance_dashboard_url`
 * - controller#action: `projects/security/compliance_dashboards#show`
 *
 * @param {string} projectFullPath
 * @param {object | undefined} options
 * @param {string | null | undefined} options.organizationPath Path of organization to nest under. Pass `null` to remove path from URL params when outside of an organization data context.
 * @returns {string} route path
 */
export const projectSecurityComplianceDashboardPath = /*#__PURE__*/ (projectFullPath, ...args) => {
  const _organizationNamespaceProjectSecurityComplianceDashboardPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"namespace_id":{"r":true},"project_id":{"r":true},"vueroute":{},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"security"],[2,[7,"/"],[2,[6,"compliance_dashboard"],[2,[1,[2,[7,"/"],[5,[3,"vueroute"]]]],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]);
  const _namespaceProjectSecurityComplianceDashboardPath = /*#__PURE__*/ __jsr.r({"namespace_id":{"r":true},"project_id":{"r":true},"vueroute":{},"format":{}}, [2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"security"],[2,[7,"/"],[2,[6,"compliance_dashboard"],[2,[1,[2,[7,"/"],[5,[3,"vueroute"]]]],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]);

  const { namespacePath, projectPath } = splitProjectFullPath(projectFullPath);
  const { organizationPath, routeArgs } = resolveOrganizationScope(args);

  if (organizationPath) {
    return _organizationNamespaceProjectSecurityComplianceDashboardPath(organizationPath, namespacePath, projectPath, ...routeArgs);
  }

  return _namespaceProjectSecurityComplianceDashboardPath(namespacePath, projectPath, ...routeArgs);
};

/**
 * Generates the Rails route:
 *
 * - href: `/:project_full_path/-/security/compliance_violations/:id(.:format)`
 * - Path helper: `project_security_compliance_violation_path`
 * - URL helper: `project_security_compliance_violation_url`
 * - controller#action: `projects/security/compliance_violations#show`
 *
 * @param {string} projectFullPath
 * @param {any} id
 * @param {object | undefined} options
 * @param {string | null | undefined} options.organizationPath Path of organization to nest under. Pass `null` to remove path from URL params when outside of an organization data context.
 * @returns {string} route path
 */
export const projectSecurityComplianceViolationPath = /*#__PURE__*/ (projectFullPath, ...args) => {
  const _organizationNamespaceProjectSecurityComplianceViolationPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"namespace_id":{"r":true},"project_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"security"],[2,[7,"/"],[2,[6,"compliance_violations"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]);
  const _namespaceProjectSecurityComplianceViolationPath = /*#__PURE__*/ __jsr.r({"namespace_id":{"r":true},"project_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"security"],[2,[7,"/"],[2,[6,"compliance_violations"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

  const { namespacePath, projectPath } = splitProjectFullPath(projectFullPath);
  const { organizationPath, routeArgs } = resolveOrganizationScope(args);

  if (organizationPath) {
    return _organizationNamespaceProjectSecurityComplianceViolationPath(organizationPath, namespacePath, projectPath, ...routeArgs);
  }

  return _namespaceProjectSecurityComplianceViolationPath(namespacePath, projectPath, ...routeArgs);
};

/**
 * Generates the Rails route:
 *
 * - href: `/:project_full_path/-/security/agent_artifacts/:id/download(.:format)`
 * - Path helper: `download_project_security_agent_artifact_path`
 * - URL helper: `download_project_security_agent_artifact_url`
 * - controller#action: `projects/security/agent_artifacts#download`
 *
 * @param {string} projectFullPath
 * @param {any} id
 * @param {object | undefined} options
 * @param {string | null | undefined} options.organizationPath Path of organization to nest under. Pass `null` to remove path from URL params when outside of an organization data context.
 * @returns {string} route path
 */
export const downloadProjectSecurityAgentArtifactPath = /*#__PURE__*/ (projectFullPath, ...args) => {
  const _downloadOrganizationNamespaceProjectSecurityAgentArtifactPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"namespace_id":{"r":true},"project_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"security"],[2,[7,"/"],[2,[6,"agent_artifacts"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"download"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]]]);
  const _downloadNamespaceProjectSecurityAgentArtifactPath = /*#__PURE__*/ __jsr.r({"namespace_id":{"r":true},"project_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"security"],[2,[7,"/"],[2,[6,"agent_artifacts"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"download"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

  const { namespacePath, projectPath } = splitProjectFullPath(projectFullPath);
  const { organizationPath, routeArgs } = resolveOrganizationScope(args);

  if (organizationPath) {
    return _downloadOrganizationNamespaceProjectSecurityAgentArtifactPath(organizationPath, namespacePath, projectPath, ...routeArgs);
  }

  return _downloadNamespaceProjectSecurityAgentArtifactPath(namespacePath, projectPath, ...routeArgs);
};

/**
 * Generates the Rails route:
 *
 * - href: `/:project_full_path/-/security/agent_artifacts/:id/download_session(.:format)`
 * - Path helper: `download_session_project_security_agent_artifact_path`
 * - URL helper: `download_session_project_security_agent_artifact_url`
 * - controller#action: `projects/security/agent_artifacts#download_session`
 *
 * @param {string} projectFullPath
 * @param {any} id
 * @param {object | undefined} options
 * @param {string | null | undefined} options.organizationPath Path of organization to nest under. Pass `null` to remove path from URL params when outside of an organization data context.
 * @returns {string} route path
 */
export const downloadSessionProjectSecurityAgentArtifactPath = /*#__PURE__*/ (projectFullPath, ...args) => {
  const _downloadSessionOrganizationNamespaceProjectSecurityAgentArtifactPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"namespace_id":{"r":true},"project_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"security"],[2,[7,"/"],[2,[6,"agent_artifacts"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"download_session"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]]]);
  const _downloadSessionNamespaceProjectSecurityAgentArtifactPath = /*#__PURE__*/ __jsr.r({"namespace_id":{"r":true},"project_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"security"],[2,[7,"/"],[2,[6,"agent_artifacts"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"download_session"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

  const { namespacePath, projectPath } = splitProjectFullPath(projectFullPath);
  const { organizationPath, routeArgs } = resolveOrganizationScope(args);

  if (organizationPath) {
    return _downloadSessionOrganizationNamespaceProjectSecurityAgentArtifactPath(organizationPath, namespacePath, projectPath, ...routeArgs);
  }

  return _downloadSessionNamespaceProjectSecurityAgentArtifactPath(namespacePath, projectPath, ...routeArgs);
};

/**
 * Generates the Rails route:
 *
 * - href: `/:project_full_path/-/security/policies/schema(.:format)`
 * - Path helper: `schema_project_security_policies_path`
 * - URL helper: `schema_project_security_policies_url`
 * - controller#action: `projects/security/policies#schema`
 *
 * @param {string} projectFullPath
 * @param {object | undefined} options
 * @param {string | null | undefined} options.organizationPath Path of organization to nest under. Pass `null` to remove path from URL params when outside of an organization data context.
 * @returns {string} route path
 */
export const schemaProjectSecurityPoliciesPath = /*#__PURE__*/ (projectFullPath, ...args) => {
  const _schemaOrganizationNamespaceProjectSecurityPoliciesPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"namespace_id":{"r":true},"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"security"],[2,[7,"/"],[2,[6,"policies"],[2,[7,"/"],[2,[6,"schema"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]);
  const _schemaNamespaceProjectSecurityPoliciesPath = /*#__PURE__*/ __jsr.r({"namespace_id":{"r":true},"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"security"],[2,[7,"/"],[2,[6,"policies"],[2,[7,"/"],[2,[6,"schema"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

  const { namespacePath, projectPath } = splitProjectFullPath(projectFullPath);
  const { organizationPath, routeArgs } = resolveOrganizationScope(args);

  if (organizationPath) {
    return _schemaOrganizationNamespaceProjectSecurityPoliciesPath(organizationPath, namespacePath, projectPath, ...routeArgs);
  }

  return _schemaNamespaceProjectSecurityPoliciesPath(namespacePath, projectPath, ...routeArgs);
};

/**
 * Generates the Rails route:
 *
 * - href: `/:project_full_path/-/security/policies(.:format)`
 * - Path helper: `project_security_policies_path`
 * - URL helper: `project_security_policies_url`
 * - controller#action: `projects/security/policies#index`
 *
 * @param {string} projectFullPath
 * @param {object | undefined} options
 * @param {string | null | undefined} options.organizationPath Path of organization to nest under. Pass `null` to remove path from URL params when outside of an organization data context.
 * @returns {string} route path
 */
export const projectSecurityPoliciesPath = /*#__PURE__*/ (projectFullPath, ...args) => {
  const _organizationNamespaceProjectSecurityPoliciesPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"namespace_id":{"r":true},"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"security"],[2,[7,"/"],[2,[6,"policies"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);
  const _namespaceProjectSecurityPoliciesPath = /*#__PURE__*/ __jsr.r({"namespace_id":{"r":true},"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"security"],[2,[7,"/"],[2,[6,"policies"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

  const { namespacePath, projectPath } = splitProjectFullPath(projectFullPath);
  const { organizationPath, routeArgs } = resolveOrganizationScope(args);

  if (organizationPath) {
    return _organizationNamespaceProjectSecurityPoliciesPath(organizationPath, namespacePath, projectPath, ...routeArgs);
  }

  return _namespaceProjectSecurityPoliciesPath(namespacePath, projectPath, ...routeArgs);
};

/**
 * Generates the Rails route:
 *
 * - href: `/:project_full_path/-/security/policies/new(.:format)`
 * - Path helper: `new_project_security_policy_path`
 * - URL helper: `new_project_security_policy_url`
 * - controller#action: `projects/security/policies#new`
 *
 * @param {string} projectFullPath
 * @param {object | undefined} options
 * @param {string | null | undefined} options.organizationPath Path of organization to nest under. Pass `null` to remove path from URL params when outside of an organization data context.
 * @returns {string} route path
 */
export const newProjectSecurityPolicyPath = /*#__PURE__*/ (projectFullPath, ...args) => {
  const _newOrganizationNamespaceProjectSecurityPolicyPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"namespace_id":{"r":true},"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"security"],[2,[7,"/"],[2,[6,"policies"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]);
  const _newNamespaceProjectSecurityPolicyPath = /*#__PURE__*/ __jsr.r({"namespace_id":{"r":true},"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"security"],[2,[7,"/"],[2,[6,"policies"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

  const { namespacePath, projectPath } = splitProjectFullPath(projectFullPath);
  const { organizationPath, routeArgs } = resolveOrganizationScope(args);

  if (organizationPath) {
    return _newOrganizationNamespaceProjectSecurityPolicyPath(organizationPath, namespacePath, projectPath, ...routeArgs);
  }

  return _newNamespaceProjectSecurityPolicyPath(namespacePath, projectPath, ...routeArgs);
};

/**
 * Generates the Rails route:
 *
 * - href: `/:project_full_path/-/security/policies/:id/edit(.:format)`
 * - Path helper: `edit_project_security_policy_path`
 * - URL helper: `edit_project_security_policy_url`
 * - controller#action: `projects/security/policies#edit`
 *
 * @param {string} projectFullPath
 * @param {any} id
 * @param {object | undefined} options
 * @param {string | null | undefined} options.organizationPath Path of organization to nest under. Pass `null` to remove path from URL params when outside of an organization data context.
 * @returns {string} route path
 */
export const editProjectSecurityPolicyPath = /*#__PURE__*/ (projectFullPath, ...args) => {
  const _editOrganizationNamespaceProjectSecurityPolicyPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"namespace_id":{"r":true},"project_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"security"],[2,[7,"/"],[2,[6,"policies"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]]]);
  const _editNamespaceProjectSecurityPolicyPath = /*#__PURE__*/ __jsr.r({"namespace_id":{"r":true},"project_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"security"],[2,[7,"/"],[2,[6,"policies"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

  const { namespacePath, projectPath } = splitProjectFullPath(projectFullPath);
  const { organizationPath, routeArgs } = resolveOrganizationScope(args);

  if (organizationPath) {
    return _editOrganizationNamespaceProjectSecurityPolicyPath(organizationPath, namespacePath, projectPath, ...routeArgs);
  }

  return _editNamespaceProjectSecurityPolicyPath(namespacePath, projectPath, ...routeArgs);
};

/**
 * Generates the Rails route:
 *
 * - href: `/:project_full_path/-/security/dependency_firewall(.:format)`
 * - Path helper: `project_security_dependency_firewall_path`
 * - URL helper: `project_security_dependency_firewall_url`
 * - controller#action: `projects/security/dependency_firewall#show`
 *
 * @param {string} projectFullPath
 * @param {object | undefined} options
 * @param {string | null | undefined} options.organizationPath Path of organization to nest under. Pass `null` to remove path from URL params when outside of an organization data context.
 * @returns {string} route path
 */
export const projectSecurityDependencyFirewallPath = /*#__PURE__*/ (projectFullPath, ...args) => {
  const _organizationNamespaceProjectSecurityDependencyFirewallPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"namespace_id":{"r":true},"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"security"],[2,[7,"/"],[2,[6,"dependency_firewall"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);
  const _namespaceProjectSecurityDependencyFirewallPath = /*#__PURE__*/ __jsr.r({"namespace_id":{"r":true},"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"security"],[2,[7,"/"],[2,[6,"dependency_firewall"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

  const { namespacePath, projectPath } = splitProjectFullPath(projectFullPath);
  const { organizationPath, routeArgs } = resolveOrganizationScope(args);

  if (organizationPath) {
    return _organizationNamespaceProjectSecurityDependencyFirewallPath(organizationPath, namespacePath, projectPath, ...routeArgs);
  }

  return _namespaceProjectSecurityDependencyFirewallPath(namespacePath, projectPath, ...routeArgs);
};

/**
 * Generates the Rails route:
 *
 * - href: `/:project_full_path/-/security/configuration/corpus_management(.:format)`
 * - Path helper: `project_security_configuration_corpus_management_path`
 * - URL helper: `project_security_configuration_corpus_management_url`
 * - controller#action: `projects/security/corpus_management#show`
 *
 * @param {string} projectFullPath
 * @param {object | undefined} options
 * @param {string | null | undefined} options.organizationPath Path of organization to nest under. Pass `null` to remove path from URL params when outside of an organization data context.
 * @returns {string} route path
 */
export const projectSecurityConfigurationCorpusManagementPath = /*#__PURE__*/ (projectFullPath, ...args) => {
  const _organizationNamespaceProjectSecurityConfigurationCorpusManagementPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"namespace_id":{"r":true},"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"security"],[2,[7,"/"],[2,[6,"configuration"],[2,[7,"/"],[2,[6,"corpus_management"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]);
  const _namespaceProjectSecurityConfigurationCorpusManagementPath = /*#__PURE__*/ __jsr.r({"namespace_id":{"r":true},"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"security"],[2,[7,"/"],[2,[6,"configuration"],[2,[7,"/"],[2,[6,"corpus_management"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

  const { namespacePath, projectPath } = splitProjectFullPath(projectFullPath);
  const { organizationPath, routeArgs } = resolveOrganizationScope(args);

  if (organizationPath) {
    return _organizationNamespaceProjectSecurityConfigurationCorpusManagementPath(organizationPath, namespacePath, projectPath, ...routeArgs);
  }

  return _namespaceProjectSecurityConfigurationCorpusManagementPath(namespacePath, projectPath, ...routeArgs);
};

/**
 * Generates the Rails route:
 *
 * - href: `/:project_full_path/-/security/configuration/api_fuzzing(.:format)`
 * - Path helper: `project_security_configuration_api_fuzzing_path`
 * - URL helper: `project_security_configuration_api_fuzzing_url`
 * - controller#action: `projects/security/api_fuzzing_configuration#show`
 *
 * @param {string} projectFullPath
 * @param {object | undefined} options
 * @param {string | null | undefined} options.organizationPath Path of organization to nest under. Pass `null` to remove path from URL params when outside of an organization data context.
 * @returns {string} route path
 */
export const projectSecurityConfigurationApiFuzzingPath = /*#__PURE__*/ (projectFullPath, ...args) => {
  const _organizationNamespaceProjectSecurityConfigurationApiFuzzingPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"namespace_id":{"r":true},"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"security"],[2,[7,"/"],[2,[6,"configuration"],[2,[7,"/"],[2,[6,"api_fuzzing"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]);
  const _namespaceProjectSecurityConfigurationApiFuzzingPath = /*#__PURE__*/ __jsr.r({"namespace_id":{"r":true},"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"security"],[2,[7,"/"],[2,[6,"configuration"],[2,[7,"/"],[2,[6,"api_fuzzing"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

  const { namespacePath, projectPath } = splitProjectFullPath(projectFullPath);
  const { organizationPath, routeArgs } = resolveOrganizationScope(args);

  if (organizationPath) {
    return _organizationNamespaceProjectSecurityConfigurationApiFuzzingPath(organizationPath, namespacePath, projectPath, ...routeArgs);
  }

  return _namespaceProjectSecurityConfigurationApiFuzzingPath(namespacePath, projectPath, ...routeArgs);
};

/**
 * Generates the Rails route:
 *
 * - href: `/:project_full_path/-/security/configuration/profile_library/dast_site_profiles/new(.:format)`
 * - Path helper: `new_project_security_configuration_profile_library_dast_site_profile_path`
 * - URL helper: `new_project_security_configuration_profile_library_dast_site_profile_url`
 * - controller#action: `projects/security/dast_site_profiles#new`
 *
 * @param {string} projectFullPath
 * @param {object | undefined} options
 * @param {string | null | undefined} options.organizationPath Path of organization to nest under. Pass `null` to remove path from URL params when outside of an organization data context.
 * @returns {string} route path
 */
export const newProjectSecurityConfigurationProfileLibraryDastSiteProfilePath = /*#__PURE__*/ (projectFullPath, ...args) => {
  const _newOrganizationNamespaceProjectSecurityConfigurationProfileLibraryDastSiteProfilePath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"namespace_id":{"r":true},"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"security"],[2,[7,"/"],[2,[6,"configuration"],[2,[7,"/"],[2,[6,"profile_library"],[2,[7,"/"],[2,[6,"dast_site_profiles"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]]]]]);
  const _newNamespaceProjectSecurityConfigurationProfileLibraryDastSiteProfilePath = /*#__PURE__*/ __jsr.r({"namespace_id":{"r":true},"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"security"],[2,[7,"/"],[2,[6,"configuration"],[2,[7,"/"],[2,[6,"profile_library"],[2,[7,"/"],[2,[6,"dast_site_profiles"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]);

  const { namespacePath, projectPath } = splitProjectFullPath(projectFullPath);
  const { organizationPath, routeArgs } = resolveOrganizationScope(args);

  if (organizationPath) {
    return _newOrganizationNamespaceProjectSecurityConfigurationProfileLibraryDastSiteProfilePath(organizationPath, namespacePath, projectPath, ...routeArgs);
  }

  return _newNamespaceProjectSecurityConfigurationProfileLibraryDastSiteProfilePath(namespacePath, projectPath, ...routeArgs);
};

/**
 * Generates the Rails route:
 *
 * - href: `/:project_full_path/-/security/configuration/profile_library/dast_site_profiles/:id/edit(.:format)`
 * - Path helper: `edit_project_security_configuration_profile_library_dast_site_profile_path`
 * - URL helper: `edit_project_security_configuration_profile_library_dast_site_profile_url`
 * - controller#action: `projects/security/dast_site_profiles#edit`
 *
 * @param {string} projectFullPath
 * @param {any} id
 * @param {object | undefined} options
 * @param {string | null | undefined} options.organizationPath Path of organization to nest under. Pass `null` to remove path from URL params when outside of an organization data context.
 * @returns {string} route path
 */
export const editProjectSecurityConfigurationProfileLibraryDastSiteProfilePath = /*#__PURE__*/ (projectFullPath, ...args) => {
  const _editOrganizationNamespaceProjectSecurityConfigurationProfileLibraryDastSiteProfilePath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"namespace_id":{"r":true},"project_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"security"],[2,[7,"/"],[2,[6,"configuration"],[2,[7,"/"],[2,[6,"profile_library"],[2,[7,"/"],[2,[6,"dast_site_profiles"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]]]]]]]);
  const _editNamespaceProjectSecurityConfigurationProfileLibraryDastSiteProfilePath = /*#__PURE__*/ __jsr.r({"namespace_id":{"r":true},"project_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"security"],[2,[7,"/"],[2,[6,"configuration"],[2,[7,"/"],[2,[6,"profile_library"],[2,[7,"/"],[2,[6,"dast_site_profiles"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]]]);

  const { namespacePath, projectPath } = splitProjectFullPath(projectFullPath);
  const { organizationPath, routeArgs } = resolveOrganizationScope(args);

  if (organizationPath) {
    return _editOrganizationNamespaceProjectSecurityConfigurationProfileLibraryDastSiteProfilePath(organizationPath, namespacePath, projectPath, ...routeArgs);
  }

  return _editNamespaceProjectSecurityConfigurationProfileLibraryDastSiteProfilePath(namespacePath, projectPath, ...routeArgs);
};

/**
 * Generates the Rails route:
 *
 * - href: `/:project_full_path/-/security/configuration/profile_library/dast_scanner_profiles/new(.:format)`
 * - Path helper: `new_project_security_configuration_profile_library_dast_scanner_profile_path`
 * - URL helper: `new_project_security_configuration_profile_library_dast_scanner_profile_url`
 * - controller#action: `projects/security/dast_scanner_profiles#new`
 *
 * @param {string} projectFullPath
 * @param {object | undefined} options
 * @param {string | null | undefined} options.organizationPath Path of organization to nest under. Pass `null` to remove path from URL params when outside of an organization data context.
 * @returns {string} route path
 */
export const newProjectSecurityConfigurationProfileLibraryDastScannerProfilePath = /*#__PURE__*/ (projectFullPath, ...args) => {
  const _newOrganizationNamespaceProjectSecurityConfigurationProfileLibraryDastScannerProfilePath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"namespace_id":{"r":true},"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"security"],[2,[7,"/"],[2,[6,"configuration"],[2,[7,"/"],[2,[6,"profile_library"],[2,[7,"/"],[2,[6,"dast_scanner_profiles"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]]]]]);
  const _newNamespaceProjectSecurityConfigurationProfileLibraryDastScannerProfilePath = /*#__PURE__*/ __jsr.r({"namespace_id":{"r":true},"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"security"],[2,[7,"/"],[2,[6,"configuration"],[2,[7,"/"],[2,[6,"profile_library"],[2,[7,"/"],[2,[6,"dast_scanner_profiles"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]);

  const { namespacePath, projectPath } = splitProjectFullPath(projectFullPath);
  const { organizationPath, routeArgs } = resolveOrganizationScope(args);

  if (organizationPath) {
    return _newOrganizationNamespaceProjectSecurityConfigurationProfileLibraryDastScannerProfilePath(organizationPath, namespacePath, projectPath, ...routeArgs);
  }

  return _newNamespaceProjectSecurityConfigurationProfileLibraryDastScannerProfilePath(namespacePath, projectPath, ...routeArgs);
};

/**
 * Generates the Rails route:
 *
 * - href: `/:project_full_path/-/security/configuration/profile_library/dast_scanner_profiles/:id/edit(.:format)`
 * - Path helper: `edit_project_security_configuration_profile_library_dast_scanner_profile_path`
 * - URL helper: `edit_project_security_configuration_profile_library_dast_scanner_profile_url`
 * - controller#action: `projects/security/dast_scanner_profiles#edit`
 *
 * @param {string} projectFullPath
 * @param {any} id
 * @param {object | undefined} options
 * @param {string | null | undefined} options.organizationPath Path of organization to nest under. Pass `null` to remove path from URL params when outside of an organization data context.
 * @returns {string} route path
 */
export const editProjectSecurityConfigurationProfileLibraryDastScannerProfilePath = /*#__PURE__*/ (projectFullPath, ...args) => {
  const _editOrganizationNamespaceProjectSecurityConfigurationProfileLibraryDastScannerProfilePath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"namespace_id":{"r":true},"project_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"security"],[2,[7,"/"],[2,[6,"configuration"],[2,[7,"/"],[2,[6,"profile_library"],[2,[7,"/"],[2,[6,"dast_scanner_profiles"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]]]]]]]);
  const _editNamespaceProjectSecurityConfigurationProfileLibraryDastScannerProfilePath = /*#__PURE__*/ __jsr.r({"namespace_id":{"r":true},"project_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"security"],[2,[7,"/"],[2,[6,"configuration"],[2,[7,"/"],[2,[6,"profile_library"],[2,[7,"/"],[2,[6,"dast_scanner_profiles"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]]]);

  const { namespacePath, projectPath } = splitProjectFullPath(projectFullPath);
  const { organizationPath, routeArgs } = resolveOrganizationScope(args);

  if (organizationPath) {
    return _editOrganizationNamespaceProjectSecurityConfigurationProfileLibraryDastScannerProfilePath(organizationPath, namespacePath, projectPath, ...routeArgs);
  }

  return _editNamespaceProjectSecurityConfigurationProfileLibraryDastScannerProfilePath(namespacePath, projectPath, ...routeArgs);
};

/**
 * Generates the Rails route:
 *
 * - href: `/:project_full_path/-/security/configuration/profile_library(.:format)`
 * - Path helper: `project_security_configuration_profile_library_path`
 * - URL helper: `project_security_configuration_profile_library_url`
 * - controller#action: `projects/security/dast_profiles#show`
 *
 * @param {string} projectFullPath
 * @param {object | undefined} options
 * @param {string | null | undefined} options.organizationPath Path of organization to nest under. Pass `null` to remove path from URL params when outside of an organization data context.
 * @returns {string} route path
 */
export const projectSecurityConfigurationProfileLibraryPath = /*#__PURE__*/ (projectFullPath, ...args) => {
  const _organizationNamespaceProjectSecurityConfigurationProfileLibraryPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"namespace_id":{"r":true},"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"security"],[2,[7,"/"],[2,[6,"configuration"],[2,[7,"/"],[2,[6,"profile_library"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]);
  const _namespaceProjectSecurityConfigurationProfileLibraryPath = /*#__PURE__*/ __jsr.r({"namespace_id":{"r":true},"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"security"],[2,[7,"/"],[2,[6,"configuration"],[2,[7,"/"],[2,[6,"profile_library"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

  const { namespacePath, projectPath } = splitProjectFullPath(projectFullPath);
  const { organizationPath, routeArgs } = resolveOrganizationScope(args);

  if (organizationPath) {
    return _organizationNamespaceProjectSecurityConfigurationProfileLibraryPath(organizationPath, namespacePath, projectPath, ...routeArgs);
  }

  return _namespaceProjectSecurityConfigurationProfileLibraryPath(namespacePath, projectPath, ...routeArgs);
};

/**
 * Generates the Rails route:
 *
 * - href: `/:project_full_path/-/security/configuration/dast(.:format)`
 * - Path helper: `project_security_configuration_dast_path`
 * - URL helper: `project_security_configuration_dast_url`
 * - controller#action: `projects/security/dast_configuration#show`
 *
 * @param {string} projectFullPath
 * @param {object | undefined} options
 * @param {string | null | undefined} options.organizationPath Path of organization to nest under. Pass `null` to remove path from URL params when outside of an organization data context.
 * @returns {string} route path
 */
export const projectSecurityConfigurationDastPath = /*#__PURE__*/ (projectFullPath, ...args) => {
  const _organizationNamespaceProjectSecurityConfigurationDastPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"namespace_id":{"r":true},"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"security"],[2,[7,"/"],[2,[6,"configuration"],[2,[7,"/"],[2,[6,"dast"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]);
  const _namespaceProjectSecurityConfigurationDastPath = /*#__PURE__*/ __jsr.r({"namespace_id":{"r":true},"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"security"],[2,[7,"/"],[2,[6,"configuration"],[2,[7,"/"],[2,[6,"dast"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

  const { namespacePath, projectPath } = splitProjectFullPath(projectFullPath);
  const { organizationPath, routeArgs } = resolveOrganizationScope(args);

  if (organizationPath) {
    return _organizationNamespaceProjectSecurityConfigurationDastPath(organizationPath, namespacePath, projectPath, ...routeArgs);
  }

  return _namespaceProjectSecurityConfigurationDastPath(namespacePath, projectPath, ...routeArgs);
};

/**
 * Generates the Rails route:
 *
 * - href: `/:project_full_path/-/security/configuration/secret_detection(.:format)`
 * - Path helper: `project_security_configuration_secret_detection_path`
 * - URL helper: `project_security_configuration_secret_detection_url`
 * - controller#action: `projects/security/secret_detection_configuration#show`
 *
 * @param {string} projectFullPath
 * @param {object | undefined} options
 * @param {string | null | undefined} options.organizationPath Path of organization to nest under. Pass `null` to remove path from URL params when outside of an organization data context.
 * @returns {string} route path
 */
export const projectSecurityConfigurationSecretDetectionPath = /*#__PURE__*/ (projectFullPath, ...args) => {
  const _organizationNamespaceProjectSecurityConfigurationSecretDetectionPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"namespace_id":{"r":true},"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"security"],[2,[7,"/"],[2,[6,"configuration"],[2,[7,"/"],[2,[6,"secret_detection"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]);
  const _namespaceProjectSecurityConfigurationSecretDetectionPath = /*#__PURE__*/ __jsr.r({"namespace_id":{"r":true},"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"security"],[2,[7,"/"],[2,[6,"configuration"],[2,[7,"/"],[2,[6,"secret_detection"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

  const { namespacePath, projectPath } = splitProjectFullPath(projectFullPath);
  const { organizationPath, routeArgs } = resolveOrganizationScope(args);

  if (organizationPath) {
    return _organizationNamespaceProjectSecurityConfigurationSecretDetectionPath(organizationPath, namespacePath, projectPath, ...routeArgs);
  }

  return _namespaceProjectSecurityConfigurationSecretDetectionPath(namespacePath, projectPath, ...routeArgs);
};

/**
 * Generates the Rails route:
 *
 * - href: `/:project_full_path/-/security/discover(.:format)`
 * - Path helper: `project_security_discover_path`
 * - URL helper: `project_security_discover_url`
 * - controller#action: `projects/security/discover#show`
 *
 * @param {string} projectFullPath
 * @param {object | undefined} options
 * @param {string | null | undefined} options.organizationPath Path of organization to nest under. Pass `null` to remove path from URL params when outside of an organization data context.
 * @returns {string} route path
 */
export const projectSecurityDiscoverPath = /*#__PURE__*/ (projectFullPath, ...args) => {
  const _organizationNamespaceProjectSecurityDiscoverPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"namespace_id":{"r":true},"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"security"],[2,[7,"/"],[2,[6,"discover"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);
  const _namespaceProjectSecurityDiscoverPath = /*#__PURE__*/ __jsr.r({"namespace_id":{"r":true},"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"security"],[2,[7,"/"],[2,[6,"discover"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

  const { namespacePath, projectPath } = splitProjectFullPath(projectFullPath);
  const { organizationPath, routeArgs } = resolveOrganizationScope(args);

  if (organizationPath) {
    return _organizationNamespaceProjectSecurityDiscoverPath(organizationPath, namespacePath, projectPath, ...routeArgs);
  }

  return _namespaceProjectSecurityDiscoverPath(namespacePath, projectPath, ...routeArgs);
};

/**
 * Generates the Rails route:
 *
 * - href: `/:project_full_path/-/security/scanned_resources(.:format)`
 * - Path helper: `project_security_scanned_resources_path`
 * - URL helper: `project_security_scanned_resources_url`
 * - controller#action: `projects/security/scanned_resources#index`
 *
 * @param {string} projectFullPath
 * @param {object | undefined} options
 * @param {string | null | undefined} options.organizationPath Path of organization to nest under. Pass `null` to remove path from URL params when outside of an organization data context.
 * @returns {string} route path
 */
export const projectSecurityScannedResourcesPath = /*#__PURE__*/ (projectFullPath, ...args) => {
  const _organizationNamespaceProjectSecurityScannedResourcesPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"namespace_id":{"r":true},"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"security"],[2,[7,"/"],[2,[6,"scanned_resources"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);
  const _namespaceProjectSecurityScannedResourcesPath = /*#__PURE__*/ __jsr.r({"namespace_id":{"r":true},"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"security"],[2,[7,"/"],[2,[6,"scanned_resources"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

  const { namespacePath, projectPath } = splitProjectFullPath(projectFullPath);
  const { organizationPath, routeArgs } = resolveOrganizationScope(args);

  if (organizationPath) {
    return _organizationNamespaceProjectSecurityScannedResourcesPath(organizationPath, namespacePath, projectPath, ...routeArgs);
  }

  return _namespaceProjectSecurityScannedResourcesPath(namespacePath, projectPath, ...routeArgs);
};

/**
 * Generates the Rails route:
 *
 * - href: `/:project_full_path/-/security/vulnerabilities/:id/discussions(.:format)`
 * - Path helper: `discussions_project_security_vulnerability_path`
 * - URL helper: `discussions_project_security_vulnerability_url`
 * - controller#action: `projects/security/vulnerabilities#discussions`
 *
 * @param {string} projectFullPath
 * @param {any} id
 * @param {object | undefined} options
 * @param {string | null | undefined} options.organizationPath Path of organization to nest under. Pass `null` to remove path from URL params when outside of an organization data context.
 * @returns {string} route path
 */
export const discussionsProjectSecurityVulnerabilityPath = /*#__PURE__*/ (projectFullPath, ...args) => {
  const _discussionsOrganizationNamespaceProjectSecurityVulnerabilityPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"namespace_id":{"r":true},"project_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"security"],[2,[7,"/"],[2,[6,"vulnerabilities"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"discussions"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]]]);
  const _discussionsNamespaceProjectSecurityVulnerabilityPath = /*#__PURE__*/ __jsr.r({"namespace_id":{"r":true},"project_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"security"],[2,[7,"/"],[2,[6,"vulnerabilities"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"discussions"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

  const { namespacePath, projectPath } = splitProjectFullPath(projectFullPath);
  const { organizationPath, routeArgs } = resolveOrganizationScope(args);

  if (organizationPath) {
    return _discussionsOrganizationNamespaceProjectSecurityVulnerabilityPath(organizationPath, namespacePath, projectPath, ...routeArgs);
  }

  return _discussionsNamespaceProjectSecurityVulnerabilityPath(namespacePath, projectPath, ...routeArgs);
};

/**
 * Generates the Rails route:
 *
 * - href: `/:project_full_path/-/security/vulnerabilities/:vulnerability_id/notes(.:format)`
 * - Path helper: `project_security_vulnerability_notes_path`
 * - URL helper: `project_security_vulnerability_notes_url`
 * - controller#action: `projects/security/vulnerabilities/notes#index`
 *
 * @param {string} projectFullPath
 * @param {any} vulnerabilityId
 * @param {object | undefined} options
 * @param {string | null | undefined} options.organizationPath Path of organization to nest under. Pass `null` to remove path from URL params when outside of an organization data context.
 * @returns {string} route path
 */
export const projectSecurityVulnerabilityNotesPath = /*#__PURE__*/ (projectFullPath, ...args) => {
  const _organizationNamespaceProjectSecurityVulnerabilityNotesPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"namespace_id":{"r":true},"project_id":{"r":true},"vulnerability_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"security"],[2,[7,"/"],[2,[6,"vulnerabilities"],[2,[7,"/"],[2,[3,"vulnerability_id"],[2,[7,"/"],[2,[6,"notes"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]]]);
  const _namespaceProjectSecurityVulnerabilityNotesPath = /*#__PURE__*/ __jsr.r({"namespace_id":{"r":true},"project_id":{"r":true},"vulnerability_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"security"],[2,[7,"/"],[2,[6,"vulnerabilities"],[2,[7,"/"],[2,[3,"vulnerability_id"],[2,[7,"/"],[2,[6,"notes"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

  const { namespacePath, projectPath } = splitProjectFullPath(projectFullPath);
  const { organizationPath, routeArgs } = resolveOrganizationScope(args);

  if (organizationPath) {
    return _organizationNamespaceProjectSecurityVulnerabilityNotesPath(organizationPath, namespacePath, projectPath, ...routeArgs);
  }

  return _namespaceProjectSecurityVulnerabilityNotesPath(namespacePath, projectPath, ...routeArgs);
};

/**
 * Generates the Rails route:
 *
 * - href: `/:project_full_path/-/security/vulnerabilities/:vulnerability_id/notes/:id(.:format)`
 * - Path helper: `project_security_vulnerability_note_path`
 * - URL helper: `project_security_vulnerability_note_url`
 * - controller#action: `projects/security/vulnerabilities/notes#update`
 *
 * @param {string} projectFullPath
 * @param {any} vulnerabilityId
 * @param {any} id
 * @param {object | undefined} options
 * @param {string | null | undefined} options.organizationPath Path of organization to nest under. Pass `null` to remove path from URL params when outside of an organization data context.
 * @returns {string} route path
 */
export const projectSecurityVulnerabilityNotePath = /*#__PURE__*/ (projectFullPath, ...args) => {
  const _organizationNamespaceProjectSecurityVulnerabilityNotePath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"namespace_id":{"r":true},"project_id":{"r":true},"vulnerability_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"security"],[2,[7,"/"],[2,[6,"vulnerabilities"],[2,[7,"/"],[2,[3,"vulnerability_id"],[2,[7,"/"],[2,[6,"notes"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]]]]]);
  const _namespaceProjectSecurityVulnerabilityNotePath = /*#__PURE__*/ __jsr.r({"namespace_id":{"r":true},"project_id":{"r":true},"vulnerability_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"security"],[2,[7,"/"],[2,[6,"vulnerabilities"],[2,[7,"/"],[2,[3,"vulnerability_id"],[2,[7,"/"],[2,[6,"notes"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]);

  const { namespacePath, projectPath } = splitProjectFullPath(projectFullPath);
  const { organizationPath, routeArgs } = resolveOrganizationScope(args);

  if (organizationPath) {
    return _organizationNamespaceProjectSecurityVulnerabilityNotePath(organizationPath, namespacePath, projectPath, ...routeArgs);
  }

  return _namespaceProjectSecurityVulnerabilityNotePath(namespacePath, projectPath, ...routeArgs);
};

/**
 * Generates the Rails route:
 *
 * - href: `/:project_full_path/-/security/vulnerabilities/new(.:format)`
 * - Path helper: `new_project_security_vulnerability_path`
 * - URL helper: `new_project_security_vulnerability_url`
 * - controller#action: `projects/security/vulnerabilities#new`
 *
 * @param {string} projectFullPath
 * @param {object | undefined} options
 * @param {string | null | undefined} options.organizationPath Path of organization to nest under. Pass `null` to remove path from URL params when outside of an organization data context.
 * @returns {string} route path
 */
export const newProjectSecurityVulnerabilityPath = /*#__PURE__*/ (projectFullPath, ...args) => {
  const _newOrganizationNamespaceProjectSecurityVulnerabilityPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"namespace_id":{"r":true},"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"security"],[2,[7,"/"],[2,[6,"vulnerabilities"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]);
  const _newNamespaceProjectSecurityVulnerabilityPath = /*#__PURE__*/ __jsr.r({"namespace_id":{"r":true},"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"security"],[2,[7,"/"],[2,[6,"vulnerabilities"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

  const { namespacePath, projectPath } = splitProjectFullPath(projectFullPath);
  const { organizationPath, routeArgs } = resolveOrganizationScope(args);

  if (organizationPath) {
    return _newOrganizationNamespaceProjectSecurityVulnerabilityPath(organizationPath, namespacePath, projectPath, ...routeArgs);
  }

  return _newNamespaceProjectSecurityVulnerabilityPath(namespacePath, projectPath, ...routeArgs);
};

/**
 * Generates the Rails route:
 *
 * - href: `/:project_full_path/-/security/vulnerabilities/:id(.:format)`
 * - Path helper: `project_security_vulnerability_path`
 * - URL helper: `project_security_vulnerability_url`
 * - controller#action: `projects/security/vulnerabilities#show`
 *
 * @param {string} projectFullPath
 * @param {any} id
 * @param {object | undefined} options
 * @param {string | null | undefined} options.organizationPath Path of organization to nest under. Pass `null` to remove path from URL params when outside of an organization data context.
 * @returns {string} route path
 */
export const projectSecurityVulnerabilityPath = /*#__PURE__*/ (projectFullPath, ...args) => {
  const _organizationNamespaceProjectSecurityVulnerabilityPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"namespace_id":{"r":true},"project_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"security"],[2,[7,"/"],[2,[6,"vulnerabilities"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]);
  const _namespaceProjectSecurityVulnerabilityPath = /*#__PURE__*/ __jsr.r({"namespace_id":{"r":true},"project_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"security"],[2,[7,"/"],[2,[6,"vulnerabilities"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

  const { namespacePath, projectPath } = splitProjectFullPath(projectFullPath);
  const { organizationPath, routeArgs } = resolveOrganizationScope(args);

  if (organizationPath) {
    return _organizationNamespaceProjectSecurityVulnerabilityPath(organizationPath, namespacePath, projectPath, ...routeArgs);
  }

  return _namespaceProjectSecurityVulnerabilityPath(namespacePath, projectPath, ...routeArgs);
};

/**
 * Generates the Rails route:
 *
 * - href: `/:project_full_path/-/analytics/code_reviews(.:format)`
 * - Path helper: `project_analytics_code_reviews_path`
 * - URL helper: `project_analytics_code_reviews_url`
 * - controller#action: `projects/analytics/code_reviews#index`
 *
 * @param {string} projectFullPath
 * @param {object | undefined} options
 * @param {string | null | undefined} options.organizationPath Path of organization to nest under. Pass `null` to remove path from URL params when outside of an organization data context.
 * @returns {string} route path
 */
export const projectAnalyticsCodeReviewsPath = /*#__PURE__*/ (projectFullPath, ...args) => {
  const _organizationNamespaceProjectAnalyticsCodeReviewsPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"namespace_id":{"r":true},"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"analytics"],[2,[7,"/"],[2,[6,"code_reviews"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);
  const _namespaceProjectAnalyticsCodeReviewsPath = /*#__PURE__*/ __jsr.r({"namespace_id":{"r":true},"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"analytics"],[2,[7,"/"],[2,[6,"code_reviews"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

  const { namespacePath, projectPath } = splitProjectFullPath(projectFullPath);
  const { organizationPath, routeArgs } = resolveOrganizationScope(args);

  if (organizationPath) {
    return _organizationNamespaceProjectAnalyticsCodeReviewsPath(organizationPath, namespacePath, projectPath, ...routeArgs);
  }

  return _namespaceProjectAnalyticsCodeReviewsPath(namespacePath, projectPath, ...routeArgs);
};

/**
 * Generates the Rails route:
 *
 * - href: `/:project_full_path/-/analytics/issues_analytics(.:format)`
 * - Path helper: `project_analytics_issues_analytics_path`
 * - URL helper: `project_analytics_issues_analytics_url`
 * - controller#action: `projects/analytics/issues_analytics#show`
 *
 * @param {string} projectFullPath
 * @param {object | undefined} options
 * @param {string | null | undefined} options.organizationPath Path of organization to nest under. Pass `null` to remove path from URL params when outside of an organization data context.
 * @returns {string} route path
 */
export const projectAnalyticsIssuesAnalyticsPath = /*#__PURE__*/ (projectFullPath, ...args) => {
  const _organizationNamespaceProjectAnalyticsIssuesAnalyticsPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"namespace_id":{"r":true},"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"analytics"],[2,[7,"/"],[2,[6,"issues_analytics"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);
  const _namespaceProjectAnalyticsIssuesAnalyticsPath = /*#__PURE__*/ __jsr.r({"namespace_id":{"r":true},"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"analytics"],[2,[7,"/"],[2,[6,"issues_analytics"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

  const { namespacePath, projectPath } = splitProjectFullPath(projectFullPath);
  const { organizationPath, routeArgs } = resolveOrganizationScope(args);

  if (organizationPath) {
    return _organizationNamespaceProjectAnalyticsIssuesAnalyticsPath(organizationPath, namespacePath, projectPath, ...routeArgs);
  }

  return _namespaceProjectAnalyticsIssuesAnalyticsPath(namespacePath, projectPath, ...routeArgs);
};

/**
 * Generates the Rails route:
 *
 * - href: `/:project_full_path/-/analytics/merge_request_analytics(.:format)`
 * - Path helper: `project_analytics_merge_request_analytics_path`
 * - URL helper: `project_analytics_merge_request_analytics_url`
 *
 * @param {string} projectFullPath
 * @param {object | undefined} options
 * @param {string | null | undefined} options.organizationPath Path of organization to nest under. Pass `null` to remove path from URL params when outside of an organization data context.
 * @returns {string} route path
 */
export const projectAnalyticsMergeRequestAnalyticsPath = /*#__PURE__*/ (projectFullPath, ...args) => {
  const _organizationNamespaceProjectAnalyticsMergeRequestAnalyticsPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"namespace_id":{"r":true},"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"analytics"],[2,[7,"/"],[2,[6,"merge_request_analytics"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);
  const _namespaceProjectAnalyticsMergeRequestAnalyticsPath = /*#__PURE__*/ __jsr.r({"namespace_id":{"r":true},"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"analytics"],[2,[7,"/"],[2,[6,"merge_request_analytics"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

  const { namespacePath, projectPath } = splitProjectFullPath(projectFullPath);
  const { organizationPath, routeArgs } = resolveOrganizationScope(args);

  if (organizationPath) {
    return _organizationNamespaceProjectAnalyticsMergeRequestAnalyticsPath(organizationPath, namespacePath, projectPath, ...routeArgs);
  }

  return _namespaceProjectAnalyticsMergeRequestAnalyticsPath(namespacePath, projectPath, ...routeArgs);
};

/**
 * Generates the Rails route:
 *
 * - href: `/:project_full_path/-/analytics/dashboards(/*vueroute)`
 * - Path helper: `project_analytics_dashboards_path`
 * - URL helper: `project_analytics_dashboards_url`
 * - controller#action: `projects/analytics/dashboards#index`
 *
 * @param {string} projectFullPath
 * @param {object | undefined} options
 * @param {string | null | undefined} options.organizationPath Path of organization to nest under. Pass `null` to remove path from URL params when outside of an organization data context.
 * @returns {string} route path
 */
export const projectAnalyticsDashboardsPath = /*#__PURE__*/ (projectFullPath, ...args) => {
  const _organizationNamespaceProjectAnalyticsDashboardsPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"namespace_id":{"r":true},"project_id":{"r":true},"vueroute":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"analytics"],[2,[7,"/"],[2,[6,"dashboards"],[1,[2,[7,"/"],[5,[3,"vueroute"]]]]]]]]]]]]]]]]]]);
  const _namespaceProjectAnalyticsDashboardsPath = /*#__PURE__*/ __jsr.r({"namespace_id":{"r":true},"project_id":{"r":true},"vueroute":{}}, [2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"analytics"],[2,[7,"/"],[2,[6,"dashboards"],[1,[2,[7,"/"],[5,[3,"vueroute"]]]]]]]]]]]]]]);

  const { namespacePath, projectPath } = splitProjectFullPath(projectFullPath);
  const { organizationPath, routeArgs } = resolveOrganizationScope(args);

  if (organizationPath) {
    return _organizationNamespaceProjectAnalyticsDashboardsPath(organizationPath, namespacePath, projectPath, ...routeArgs);
  }

  return _namespaceProjectAnalyticsDashboardsPath(namespacePath, projectPath, ...routeArgs);
};

/**
 * Generates the Rails route:
 *
 * - href: `/:project_full_path/-/analytics/value_stream_analytics/value_streams(.:format)`
 * - Path helper: `project_analytics_cycle_analytics_value_streams_path`
 * - URL helper: `project_analytics_cycle_analytics_value_streams_url`
 * - controller#action: `projects/analytics/cycle_analytics/value_streams#index`
 *
 * @param {string} projectFullPath
 * @param {object | undefined} options
 * @param {string | null | undefined} options.organizationPath Path of organization to nest under. Pass `null` to remove path from URL params when outside of an organization data context.
 * @returns {string} route path
 */
export const projectAnalyticsCycleAnalyticsValueStreamsPath = /*#__PURE__*/ (projectFullPath, ...args) => {
  const _organizationNamespaceProjectAnalyticsCycleAnalyticsValueStreamsPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"namespace_id":{"r":true},"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"analytics"],[2,[7,"/"],[2,[6,"value_stream_analytics"],[2,[7,"/"],[2,[6,"value_streams"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]);
  const _namespaceProjectAnalyticsCycleAnalyticsValueStreamsPath = /*#__PURE__*/ __jsr.r({"namespace_id":{"r":true},"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"analytics"],[2,[7,"/"],[2,[6,"value_stream_analytics"],[2,[7,"/"],[2,[6,"value_streams"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

  const { namespacePath, projectPath } = splitProjectFullPath(projectFullPath);
  const { organizationPath, routeArgs } = resolveOrganizationScope(args);

  if (organizationPath) {
    return _organizationNamespaceProjectAnalyticsCycleAnalyticsValueStreamsPath(organizationPath, namespacePath, projectPath, ...routeArgs);
  }

  return _namespaceProjectAnalyticsCycleAnalyticsValueStreamsPath(namespacePath, projectPath, ...routeArgs);
};

/**
 * Generates the Rails route:
 *
 * - href: `/:project_full_path/-/analytics/value_stream_analytics/value_streams/new(.:format)`
 * - Path helper: `new_project_analytics_cycle_analytics_value_stream_path`
 * - URL helper: `new_project_analytics_cycle_analytics_value_stream_url`
 * - controller#action: `projects/analytics/cycle_analytics/value_streams#new`
 *
 * @param {string} projectFullPath
 * @param {object | undefined} options
 * @param {string | null | undefined} options.organizationPath Path of organization to nest under. Pass `null` to remove path from URL params when outside of an organization data context.
 * @returns {string} route path
 */
export const newProjectAnalyticsCycleAnalyticsValueStreamPath = /*#__PURE__*/ (projectFullPath, ...args) => {
  const _newOrganizationNamespaceProjectAnalyticsCycleAnalyticsValueStreamPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"namespace_id":{"r":true},"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"analytics"],[2,[7,"/"],[2,[6,"value_stream_analytics"],[2,[7,"/"],[2,[6,"value_streams"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]]]);
  const _newNamespaceProjectAnalyticsCycleAnalyticsValueStreamPath = /*#__PURE__*/ __jsr.r({"namespace_id":{"r":true},"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"analytics"],[2,[7,"/"],[2,[6,"value_stream_analytics"],[2,[7,"/"],[2,[6,"value_streams"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

  const { namespacePath, projectPath } = splitProjectFullPath(projectFullPath);
  const { organizationPath, routeArgs } = resolveOrganizationScope(args);

  if (organizationPath) {
    return _newOrganizationNamespaceProjectAnalyticsCycleAnalyticsValueStreamPath(organizationPath, namespacePath, projectPath, ...routeArgs);
  }

  return _newNamespaceProjectAnalyticsCycleAnalyticsValueStreamPath(namespacePath, projectPath, ...routeArgs);
};

/**
 * Generates the Rails route:
 *
 * - href: `/:project_full_path/-/analytics/value_stream_analytics/value_streams/:id/edit(.:format)`
 * - Path helper: `edit_project_analytics_cycle_analytics_value_stream_path`
 * - URL helper: `edit_project_analytics_cycle_analytics_value_stream_url`
 * - controller#action: `projects/analytics/cycle_analytics/value_streams#edit`
 *
 * @param {string} projectFullPath
 * @param {any} id
 * @param {object | undefined} options
 * @param {string | null | undefined} options.organizationPath Path of organization to nest under. Pass `null` to remove path from URL params when outside of an organization data context.
 * @returns {string} route path
 */
export const editProjectAnalyticsCycleAnalyticsValueStreamPath = /*#__PURE__*/ (projectFullPath, ...args) => {
  const _editOrganizationNamespaceProjectAnalyticsCycleAnalyticsValueStreamPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"namespace_id":{"r":true},"project_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"analytics"],[2,[7,"/"],[2,[6,"value_stream_analytics"],[2,[7,"/"],[2,[6,"value_streams"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]]]]]);
  const _editNamespaceProjectAnalyticsCycleAnalyticsValueStreamPath = /*#__PURE__*/ __jsr.r({"namespace_id":{"r":true},"project_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"analytics"],[2,[7,"/"],[2,[6,"value_stream_analytics"],[2,[7,"/"],[2,[6,"value_streams"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]);

  const { namespacePath, projectPath } = splitProjectFullPath(projectFullPath);
  const { organizationPath, routeArgs } = resolveOrganizationScope(args);

  if (organizationPath) {
    return _editOrganizationNamespaceProjectAnalyticsCycleAnalyticsValueStreamPath(organizationPath, namespacePath, projectPath, ...routeArgs);
  }

  return _editNamespaceProjectAnalyticsCycleAnalyticsValueStreamPath(namespacePath, projectPath, ...routeArgs);
};

/**
 * Generates the Rails route:
 *
 * - href: `/:project_full_path/-/analytics/value_stream_analytics/value_streams/:id(.:format)`
 * - Path helper: `project_analytics_cycle_analytics_value_stream_path`
 * - URL helper: `project_analytics_cycle_analytics_value_stream_url`
 * - controller#action: `projects/analytics/cycle_analytics/value_streams#show`
 *
 * @param {string} projectFullPath
 * @param {any} id
 * @param {object | undefined} options
 * @param {string | null | undefined} options.organizationPath Path of organization to nest under. Pass `null` to remove path from URL params when outside of an organization data context.
 * @returns {string} route path
 */
export const projectAnalyticsCycleAnalyticsValueStreamPath = /*#__PURE__*/ (projectFullPath, ...args) => {
  const _organizationNamespaceProjectAnalyticsCycleAnalyticsValueStreamPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"namespace_id":{"r":true},"project_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"analytics"],[2,[7,"/"],[2,[6,"value_stream_analytics"],[2,[7,"/"],[2,[6,"value_streams"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]]]);
  const _namespaceProjectAnalyticsCycleAnalyticsValueStreamPath = /*#__PURE__*/ __jsr.r({"namespace_id":{"r":true},"project_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"analytics"],[2,[7,"/"],[2,[6,"value_stream_analytics"],[2,[7,"/"],[2,[6,"value_streams"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

  const { namespacePath, projectPath } = splitProjectFullPath(projectFullPath);
  const { organizationPath, routeArgs } = resolveOrganizationScope(args);

  if (organizationPath) {
    return _organizationNamespaceProjectAnalyticsCycleAnalyticsValueStreamPath(organizationPath, namespacePath, projectPath, ...routeArgs);
  }

  return _namespaceProjectAnalyticsCycleAnalyticsValueStreamPath(namespacePath, projectPath, ...routeArgs);
};

/**
 * Generates the Rails route:
 *
 * - href: `/:project_full_path/-/analytics/value_stream_analytics/value_streams/:value_stream_id/stages/:id/average_duration_chart(.:format)`
 * - Path helper: `project_analytics_cycle_analytics_average_duration_chart_path`
 * - URL helper: `project_analytics_cycle_analytics_average_duration_chart_url`
 * - controller#action: `projects/analytics/cycle_analytics/stages#average_duration_chart`
 *
 * @param {string} projectFullPath
 * @param {any} valueStreamId
 * @param {any} id
 * @param {object | undefined} options
 * @param {string | null | undefined} options.organizationPath Path of organization to nest under. Pass `null` to remove path from URL params when outside of an organization data context.
 * @returns {string} route path
 */
export const projectAnalyticsCycleAnalyticsAverageDurationChartPath = /*#__PURE__*/ (projectFullPath, ...args) => {
  const _organizationNamespaceProjectAnalyticsCycleAnalyticsAverageDurationChartPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"namespace_id":{"r":true},"project_id":{"r":true},"value_stream_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"analytics"],[2,[7,"/"],[2,[6,"value_stream_analytics"],[2,[7,"/"],[2,[6,"value_streams"],[2,[7,"/"],[2,[3,"value_stream_id"],[2,[7,"/"],[2,[6,"stages"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"average_duration_chart"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]]]]]]]]]);
  const _namespaceProjectAnalyticsCycleAnalyticsAverageDurationChartPath = /*#__PURE__*/ __jsr.r({"namespace_id":{"r":true},"project_id":{"r":true},"value_stream_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"analytics"],[2,[7,"/"],[2,[6,"value_stream_analytics"],[2,[7,"/"],[2,[6,"value_streams"],[2,[7,"/"],[2,[3,"value_stream_id"],[2,[7,"/"],[2,[6,"stages"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"average_duration_chart"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]]]]]);

  const { namespacePath, projectPath } = splitProjectFullPath(projectFullPath);
  const { organizationPath, routeArgs } = resolveOrganizationScope(args);

  if (organizationPath) {
    return _organizationNamespaceProjectAnalyticsCycleAnalyticsAverageDurationChartPath(organizationPath, namespacePath, projectPath, ...routeArgs);
  }

  return _namespaceProjectAnalyticsCycleAnalyticsAverageDurationChartPath(namespacePath, projectPath, ...routeArgs);
};

/**
 * Generates the Rails route:
 *
 * - href: `/:project_full_path/-/analytics/value_stream_analytics/time_summary(.:format)`
 * - Path helper: `project_analytics_cycle_analytics_time_summary_path`
 * - URL helper: `project_analytics_cycle_analytics_time_summary_url`
 * - controller#action: `projects/analytics/cycle_analytics/summary#time_summary`
 *
 * @param {string} projectFullPath
 * @param {object | undefined} options
 * @param {string | null | undefined} options.organizationPath Path of organization to nest under. Pass `null` to remove path from URL params when outside of an organization data context.
 * @returns {string} route path
 */
export const projectAnalyticsCycleAnalyticsTimeSummaryPath = /*#__PURE__*/ (projectFullPath, ...args) => {
  const _organizationNamespaceProjectAnalyticsCycleAnalyticsTimeSummaryPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"namespace_id":{"r":true},"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"analytics"],[2,[7,"/"],[2,[6,"value_stream_analytics"],[2,[7,"/"],[2,[6,"time_summary"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]);
  const _namespaceProjectAnalyticsCycleAnalyticsTimeSummaryPath = /*#__PURE__*/ __jsr.r({"namespace_id":{"r":true},"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"analytics"],[2,[7,"/"],[2,[6,"value_stream_analytics"],[2,[7,"/"],[2,[6,"time_summary"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

  const { namespacePath, projectPath } = splitProjectFullPath(projectFullPath);
  const { organizationPath, routeArgs } = resolveOrganizationScope(args);

  if (organizationPath) {
    return _organizationNamespaceProjectAnalyticsCycleAnalyticsTimeSummaryPath(organizationPath, namespacePath, projectPath, ...routeArgs);
  }

  return _namespaceProjectAnalyticsCycleAnalyticsTimeSummaryPath(namespacePath, projectPath, ...routeArgs);
};

/**
 * Generates the Rails route:
 *
 * - href: `/:project_full_path/-/push_rules/:id(.:format)`
 * - Path helper: `project_push_rule_path`
 * - URL helper: `project_push_rule_url`
 * - controller#action: `projects/push_rules#update`
 *
 * @param {string} projectFullPath
 * @param {any} id
 * @param {object | undefined} options
 * @param {string | null | undefined} options.organizationPath Path of organization to nest under. Pass `null` to remove path from URL params when outside of an organization data context.
 * @returns {string} route path
 */
export const projectPushRulePath = /*#__PURE__*/ (projectFullPath, ...args) => {
  const _organizationNamespaceProjectPushRulePath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"namespace_id":{"r":true},"project_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"push_rules"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);
  const _namespaceProjectPushRulePath = /*#__PURE__*/ __jsr.r({"namespace_id":{"r":true},"project_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"push_rules"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

  const { namespacePath, projectPath } = splitProjectFullPath(projectFullPath);
  const { organizationPath, routeArgs } = resolveOrganizationScope(args);

  if (organizationPath) {
    return _organizationNamespaceProjectPushRulePath(organizationPath, namespacePath, projectPath, ...routeArgs);
  }

  return _namespaceProjectPushRulePath(namespacePath, projectPath, ...routeArgs);
};

/**
 * Generates the Rails route:
 *
 * - href: `/:project_full_path/-/vulnerability_feedback(.:format)`
 * - Path helper: `project_vulnerability_feedback_index_path`
 * - URL helper: `project_vulnerability_feedback_index_url`
 * - controller#action: `projects/vulnerability_feedback#index`
 *
 * @param {string} projectFullPath
 * @param {object | undefined} options
 * @param {string | null | undefined} options.organizationPath Path of organization to nest under. Pass `null` to remove path from URL params when outside of an organization data context.
 * @returns {string} route path
 */
export const projectVulnerabilityFeedbackIndexPath = /*#__PURE__*/ (projectFullPath, ...args) => {
  const _organizationNamespaceProjectVulnerabilityFeedbackIndexPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"namespace_id":{"r":true},"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"vulnerability_feedback"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);
  const _namespaceProjectVulnerabilityFeedbackIndexPath = /*#__PURE__*/ __jsr.r({"namespace_id":{"r":true},"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"vulnerability_feedback"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

  const { namespacePath, projectPath } = splitProjectFullPath(projectFullPath);
  const { organizationPath, routeArgs } = resolveOrganizationScope(args);

  if (organizationPath) {
    return _organizationNamespaceProjectVulnerabilityFeedbackIndexPath(organizationPath, namespacePath, projectPath, ...routeArgs);
  }

  return _namespaceProjectVulnerabilityFeedbackIndexPath(namespacePath, projectPath, ...routeArgs);
};

/**
 * Generates the Rails route:
 *
 * - href: `/:project_full_path/-/vulnerability_feedback/:id(.:format)`
 * - Path helper: `project_vulnerability_feedback_path`
 * - URL helper: `project_vulnerability_feedback_url`
 * - controller#action: `projects/vulnerability_feedback#update`
 *
 * @param {string} projectFullPath
 * @param {any} id
 * @param {object | undefined} options
 * @param {string | null | undefined} options.organizationPath Path of organization to nest under. Pass `null` to remove path from URL params when outside of an organization data context.
 * @returns {string} route path
 */
export const projectVulnerabilityFeedbackPath = /*#__PURE__*/ (projectFullPath, ...args) => {
  const _organizationNamespaceProjectVulnerabilityFeedbackPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"namespace_id":{"r":true},"project_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"vulnerability_feedback"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);
  const _namespaceProjectVulnerabilityFeedbackPath = /*#__PURE__*/ __jsr.r({"namespace_id":{"r":true},"project_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"vulnerability_feedback"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

  const { namespacePath, projectPath } = splitProjectFullPath(projectFullPath);
  const { organizationPath, routeArgs } = resolveOrganizationScope(args);

  if (organizationPath) {
    return _organizationNamespaceProjectVulnerabilityFeedbackPath(organizationPath, namespacePath, projectPath, ...routeArgs);
  }

  return _namespaceProjectVulnerabilityFeedbackPath(namespacePath, projectPath, ...routeArgs);
};

/**
 * Generates the Rails route:
 *
 * - href: `/:project_full_path/-/vulnerability_feedback/count(.:format)`
 * - Path helper: `project_vulnerability_feedback_count_path`
 * - URL helper: `project_vulnerability_feedback_count_url`
 * - controller#action: `projects/vulnerability_feedback#count`
 *
 * @param {string} projectFullPath
 * @param {object | undefined} options
 * @param {string | null | undefined} options.organizationPath Path of organization to nest under. Pass `null` to remove path from URL params when outside of an organization data context.
 * @returns {string} route path
 */
export const projectVulnerabilityFeedbackCountPath = /*#__PURE__*/ (projectFullPath, ...args) => {
  const _organizationNamespaceProjectVulnerabilityFeedbackCountPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"namespace_id":{"r":true},"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"vulnerability_feedback"],[2,[7,"/"],[2,[6,"count"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);
  const _namespaceProjectVulnerabilityFeedbackCountPath = /*#__PURE__*/ __jsr.r({"namespace_id":{"r":true},"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"vulnerability_feedback"],[2,[7,"/"],[2,[6,"count"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

  const { namespacePath, projectPath } = splitProjectFullPath(projectFullPath);
  const { organizationPath, routeArgs } = resolveOrganizationScope(args);

  if (organizationPath) {
    return _organizationNamespaceProjectVulnerabilityFeedbackCountPath(organizationPath, namespacePath, projectPath, ...routeArgs);
  }

  return _namespaceProjectVulnerabilityFeedbackCountPath(namespacePath, projectPath, ...routeArgs);
};

/**
 * Generates the Rails route:
 *
 * - href: `/:project_full_path/-/dependencies/licenses(.:format)`
 * - Path helper: `licenses_project_dependencies_path`
 * - URL helper: `licenses_project_dependencies_url`
 * - controller#action: `projects/dependencies#licenses`
 *
 * @param {string} projectFullPath
 * @param {object | undefined} options
 * @param {string | null | undefined} options.organizationPath Path of organization to nest under. Pass `null` to remove path from URL params when outside of an organization data context.
 * @returns {string} route path
 */
export const licensesProjectDependenciesPath = /*#__PURE__*/ (projectFullPath, ...args) => {
  const _licensesOrganizationNamespaceProjectDependenciesPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"namespace_id":{"r":true},"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"dependencies"],[2,[7,"/"],[2,[6,"licenses"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);
  const _licensesNamespaceProjectDependenciesPath = /*#__PURE__*/ __jsr.r({"namespace_id":{"r":true},"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"dependencies"],[2,[7,"/"],[2,[6,"licenses"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

  const { namespacePath, projectPath } = splitProjectFullPath(projectFullPath);
  const { organizationPath, routeArgs } = resolveOrganizationScope(args);

  if (organizationPath) {
    return _licensesOrganizationNamespaceProjectDependenciesPath(organizationPath, namespacePath, projectPath, ...routeArgs);
  }

  return _licensesNamespaceProjectDependenciesPath(namespacePath, projectPath, ...routeArgs);
};

/**
 * Generates the Rails route:
 *
 * - href: `/:project_full_path/-/dependencies(.:format)`
 * - Path helper: `project_dependencies_path`
 * - URL helper: `project_dependencies_url`
 * - controller#action: `projects/dependencies#index`
 *
 * @param {string} projectFullPath
 * @param {object | undefined} options
 * @param {string | null | undefined} options.organizationPath Path of organization to nest under. Pass `null` to remove path from URL params when outside of an organization data context.
 * @returns {string} route path
 */
export const projectDependenciesPath = /*#__PURE__*/ (projectFullPath, ...args) => {
  const _organizationNamespaceProjectDependenciesPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"namespace_id":{"r":true},"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"dependencies"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);
  const _namespaceProjectDependenciesPath = /*#__PURE__*/ __jsr.r({"namespace_id":{"r":true},"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"dependencies"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

  const { namespacePath, projectPath } = splitProjectFullPath(projectFullPath);
  const { organizationPath, routeArgs } = resolveOrganizationScope(args);

  if (organizationPath) {
    return _organizationNamespaceProjectDependenciesPath(organizationPath, namespacePath, projectPath, ...routeArgs);
  }

  return _namespaceProjectDependenciesPath(namespacePath, projectPath, ...routeArgs);
};

/**
 * Generates the Rails route:
 *
 * - href: `/:project_full_path/-/feature_flags/:feature_flag_iid/issues(.:format)`
 * - Path helper: `project_feature_flag_issues_path`
 * - URL helper: `project_feature_flag_issues_url`
 * - controller#action: `projects/feature_flag_issues#index`
 *
 * @param {string} projectFullPath
 * @param {any} featureFlagIid
 * @param {object | undefined} options
 * @param {string | null | undefined} options.organizationPath Path of organization to nest under. Pass `null` to remove path from URL params when outside of an organization data context.
 * @returns {string} route path
 */
export const projectFeatureFlagIssuesPath = /*#__PURE__*/ (projectFullPath, ...args) => {
  const _organizationNamespaceProjectFeatureFlagIssuesPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"namespace_id":{"r":true},"project_id":{"r":true},"feature_flag_iid":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"feature_flags"],[2,[7,"/"],[2,[3,"feature_flag_iid"],[2,[7,"/"],[2,[6,"issues"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]);
  const _namespaceProjectFeatureFlagIssuesPath = /*#__PURE__*/ __jsr.r({"namespace_id":{"r":true},"project_id":{"r":true},"feature_flag_iid":{"r":true},"format":{}}, [2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"feature_flags"],[2,[7,"/"],[2,[3,"feature_flag_iid"],[2,[7,"/"],[2,[6,"issues"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

  const { namespacePath, projectPath } = splitProjectFullPath(projectFullPath);
  const { organizationPath, routeArgs } = resolveOrganizationScope(args);

  if (organizationPath) {
    return _organizationNamespaceProjectFeatureFlagIssuesPath(organizationPath, namespacePath, projectPath, ...routeArgs);
  }

  return _namespaceProjectFeatureFlagIssuesPath(namespacePath, projectPath, ...routeArgs);
};

/**
 * Generates the Rails route:
 *
 * - href: `/:project_full_path/-/feature_flags/:feature_flag_iid/issues/:id(.:format)`
 * - Path helper: `project_feature_flag_issue_path`
 * - URL helper: `project_feature_flag_issue_url`
 * - controller#action: `projects/feature_flag_issues#destroy`
 *
 * @param {string} projectFullPath
 * @param {any} featureFlagIid
 * @param {any} id
 * @param {object | undefined} options
 * @param {string | null | undefined} options.organizationPath Path of organization to nest under. Pass `null` to remove path from URL params when outside of an organization data context.
 * @returns {string} route path
 */
export const projectFeatureFlagIssuePath = /*#__PURE__*/ (projectFullPath, ...args) => {
  const _organizationNamespaceProjectFeatureFlagIssuePath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"namespace_id":{"r":true},"project_id":{"r":true},"feature_flag_iid":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"feature_flags"],[2,[7,"/"],[2,[3,"feature_flag_iid"],[2,[7,"/"],[2,[6,"issues"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]]]);
  const _namespaceProjectFeatureFlagIssuePath = /*#__PURE__*/ __jsr.r({"namespace_id":{"r":true},"project_id":{"r":true},"feature_flag_iid":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"feature_flags"],[2,[7,"/"],[2,[3,"feature_flag_iid"],[2,[7,"/"],[2,[6,"issues"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

  const { namespacePath, projectPath } = splitProjectFullPath(projectFullPath);
  const { organizationPath, routeArgs } = resolveOrganizationScope(args);

  if (organizationPath) {
    return _organizationNamespaceProjectFeatureFlagIssuePath(organizationPath, namespacePath, projectPath, ...routeArgs);
  }

  return _namespaceProjectFeatureFlagIssuePath(namespacePath, projectPath, ...routeArgs);
};

/**
 * Generates the Rails route:
 *
 * - href: `/:project_full_path/-/feature_flags(.:format)`
 * - Path helper: `project_feature_flags_path`
 * - URL helper: `project_feature_flags_url`
 * - controller#action: `projects/feature_flags#index`
 *
 * @param {string} projectFullPath
 * @param {object | undefined} options
 * @param {string | null | undefined} options.organizationPath Path of organization to nest under. Pass `null` to remove path from URL params when outside of an organization data context.
 * @returns {string} route path
 */
export const projectFeatureFlagsPath = /*#__PURE__*/ (projectFullPath, ...args) => {
  const _organizationNamespaceProjectFeatureFlagsPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"namespace_id":{"r":true},"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"feature_flags"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);
  const _namespaceProjectFeatureFlagsPath = /*#__PURE__*/ __jsr.r({"namespace_id":{"r":true},"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"feature_flags"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

  const { namespacePath, projectPath } = splitProjectFullPath(projectFullPath);
  const { organizationPath, routeArgs } = resolveOrganizationScope(args);

  if (organizationPath) {
    return _organizationNamespaceProjectFeatureFlagsPath(organizationPath, namespacePath, projectPath, ...routeArgs);
  }

  return _namespaceProjectFeatureFlagsPath(namespacePath, projectPath, ...routeArgs);
};

/**
 * Generates the Rails route:
 *
 * - href: `/:project_full_path/-/feature_flags/new(.:format)`
 * - Path helper: `new_project_feature_flag_path`
 * - URL helper: `new_project_feature_flag_url`
 * - controller#action: `projects/feature_flags#new`
 *
 * @param {string} projectFullPath
 * @param {object | undefined} options
 * @param {string | null | undefined} options.organizationPath Path of organization to nest under. Pass `null` to remove path from URL params when outside of an organization data context.
 * @returns {string} route path
 */
export const newProjectFeatureFlagPath = /*#__PURE__*/ (projectFullPath, ...args) => {
  const _newOrganizationNamespaceProjectFeatureFlagPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"namespace_id":{"r":true},"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"feature_flags"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);
  const _newNamespaceProjectFeatureFlagPath = /*#__PURE__*/ __jsr.r({"namespace_id":{"r":true},"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"feature_flags"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

  const { namespacePath, projectPath } = splitProjectFullPath(projectFullPath);
  const { organizationPath, routeArgs } = resolveOrganizationScope(args);

  if (organizationPath) {
    return _newOrganizationNamespaceProjectFeatureFlagPath(organizationPath, namespacePath, projectPath, ...routeArgs);
  }

  return _newNamespaceProjectFeatureFlagPath(namespacePath, projectPath, ...routeArgs);
};

/**
 * Generates the Rails route:
 *
 * - href: `/:project_full_path/-/feature_flags/:iid/edit(.:format)`
 * - Path helper: `edit_project_feature_flag_path`
 * - URL helper: `edit_project_feature_flag_url`
 * - controller#action: `projects/feature_flags#edit`
 *
 * @param {string} projectFullPath
 * @param {any} iid
 * @param {object | undefined} options
 * @param {string | null | undefined} options.organizationPath Path of organization to nest under. Pass `null` to remove path from URL params when outside of an organization data context.
 * @returns {string} route path
 */
export const editProjectFeatureFlagPath = /*#__PURE__*/ (projectFullPath, ...args) => {
  const _editOrganizationNamespaceProjectFeatureFlagPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"namespace_id":{"r":true},"project_id":{"r":true},"iid":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"feature_flags"],[2,[7,"/"],[2,[3,"iid"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]);
  const _editNamespaceProjectFeatureFlagPath = /*#__PURE__*/ __jsr.r({"namespace_id":{"r":true},"project_id":{"r":true},"iid":{"r":true},"format":{}}, [2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"feature_flags"],[2,[7,"/"],[2,[3,"iid"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

  const { namespacePath, projectPath } = splitProjectFullPath(projectFullPath);
  const { organizationPath, routeArgs } = resolveOrganizationScope(args);

  if (organizationPath) {
    return _editOrganizationNamespaceProjectFeatureFlagPath(organizationPath, namespacePath, projectPath, ...routeArgs);
  }

  return _editNamespaceProjectFeatureFlagPath(namespacePath, projectPath, ...routeArgs);
};

/**
 * Generates the Rails route:
 *
 * - href: `/:project_full_path/-/feature_flags/:iid(.:format)`
 * - Path helper: `project_feature_flag_path`
 * - URL helper: `project_feature_flag_url`
 * - controller#action: `projects/feature_flags#show`
 *
 * @param {string} projectFullPath
 * @param {any} iid
 * @param {object | undefined} options
 * @param {string | null | undefined} options.organizationPath Path of organization to nest under. Pass `null` to remove path from URL params when outside of an organization data context.
 * @returns {string} route path
 */
export const projectFeatureFlagPath = /*#__PURE__*/ (projectFullPath, ...args) => {
  const _organizationNamespaceProjectFeatureFlagPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"namespace_id":{"r":true},"project_id":{"r":true},"iid":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"feature_flags"],[2,[7,"/"],[2,[3,"iid"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);
  const _namespaceProjectFeatureFlagPath = /*#__PURE__*/ __jsr.r({"namespace_id":{"r":true},"project_id":{"r":true},"iid":{"r":true},"format":{}}, [2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"feature_flags"],[2,[7,"/"],[2,[3,"iid"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

  const { namespacePath, projectPath } = splitProjectFullPath(projectFullPath);
  const { organizationPath, routeArgs } = resolveOrganizationScope(args);

  if (organizationPath) {
    return _organizationNamespaceProjectFeatureFlagPath(organizationPath, namespacePath, projectPath, ...routeArgs);
  }

  return _namespaceProjectFeatureFlagPath(namespacePath, projectPath, ...routeArgs);
};

/**
 * Generates the Rails route:
 *
 * - href: `/:project_full_path/-/on_demand_scans(.:format)`
 * - Path helper: `project_on_demand_scans_path`
 * - URL helper: `project_on_demand_scans_url`
 * - controller#action: `projects/on_demand_scans#index`
 *
 * @param {string} projectFullPath
 * @param {object | undefined} options
 * @param {string | null | undefined} options.organizationPath Path of organization to nest under. Pass `null` to remove path from URL params when outside of an organization data context.
 * @returns {string} route path
 */
export const projectOnDemandScansPath = /*#__PURE__*/ (projectFullPath, ...args) => {
  const _organizationNamespaceProjectOnDemandScansPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"namespace_id":{"r":true},"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"on_demand_scans"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);
  const _namespaceProjectOnDemandScansPath = /*#__PURE__*/ __jsr.r({"namespace_id":{"r":true},"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"on_demand_scans"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

  const { namespacePath, projectPath } = splitProjectFullPath(projectFullPath);
  const { organizationPath, routeArgs } = resolveOrganizationScope(args);

  if (organizationPath) {
    return _organizationNamespaceProjectOnDemandScansPath(organizationPath, namespacePath, projectPath, ...routeArgs);
  }

  return _namespaceProjectOnDemandScansPath(namespacePath, projectPath, ...routeArgs);
};

/**
 * Generates the Rails route:
 *
 * - href: `/:project_full_path/-/on_demand_scans/new(.:format)`
 * - Path helper: `new_project_on_demand_scan_path`
 * - URL helper: `new_project_on_demand_scan_url`
 * - controller#action: `projects/on_demand_scans#new`
 *
 * @param {string} projectFullPath
 * @param {object | undefined} options
 * @param {string | null | undefined} options.organizationPath Path of organization to nest under. Pass `null` to remove path from URL params when outside of an organization data context.
 * @returns {string} route path
 */
export const newProjectOnDemandScanPath = /*#__PURE__*/ (projectFullPath, ...args) => {
  const _newOrganizationNamespaceProjectOnDemandScanPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"namespace_id":{"r":true},"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"on_demand_scans"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);
  const _newNamespaceProjectOnDemandScanPath = /*#__PURE__*/ __jsr.r({"namespace_id":{"r":true},"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"on_demand_scans"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

  const { namespacePath, projectPath } = splitProjectFullPath(projectFullPath);
  const { organizationPath, routeArgs } = resolveOrganizationScope(args);

  if (organizationPath) {
    return _newOrganizationNamespaceProjectOnDemandScanPath(organizationPath, namespacePath, projectPath, ...routeArgs);
  }

  return _newNamespaceProjectOnDemandScanPath(namespacePath, projectPath, ...routeArgs);
};

/**
 * Generates the Rails route:
 *
 * - href: `/:project_full_path/-/on_demand_scans/:id/edit(.:format)`
 * - Path helper: `edit_project_on_demand_scan_path`
 * - URL helper: `edit_project_on_demand_scan_url`
 * - controller#action: `projects/on_demand_scans#edit`
 *
 * @param {string} projectFullPath
 * @param {any} id
 * @param {object | undefined} options
 * @param {string | null | undefined} options.organizationPath Path of organization to nest under. Pass `null` to remove path from URL params when outside of an organization data context.
 * @returns {string} route path
 */
export const editProjectOnDemandScanPath = /*#__PURE__*/ (projectFullPath, ...args) => {
  const _editOrganizationNamespaceProjectOnDemandScanPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"namespace_id":{"r":true},"project_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"on_demand_scans"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]);
  const _editNamespaceProjectOnDemandScanPath = /*#__PURE__*/ __jsr.r({"namespace_id":{"r":true},"project_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"on_demand_scans"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

  const { namespacePath, projectPath } = splitProjectFullPath(projectFullPath);
  const { organizationPath, routeArgs } = resolveOrganizationScope(args);

  if (organizationPath) {
    return _editOrganizationNamespaceProjectOnDemandScanPath(organizationPath, namespacePath, projectPath, ...routeArgs);
  }

  return _editNamespaceProjectOnDemandScanPath(namespacePath, projectPath, ...routeArgs);
};

/**
 * Generates the Rails route:
 *
 * - href: `/:project_full_path/-/integrations/jira/issues(.:format)`
 * - Path helper: `project_integrations_jira_issues_path`
 * - URL helper: `project_integrations_jira_issues_url`
 * - controller#action: `projects/integrations/jira/issues#index`
 *
 * @param {string} projectFullPath
 * @param {object | undefined} options
 * @param {string | null | undefined} options.organizationPath Path of organization to nest under. Pass `null` to remove path from URL params when outside of an organization data context.
 * @returns {string} route path
 */
export const projectIntegrationsJiraIssuesPath = /*#__PURE__*/ (projectFullPath, ...args) => {
  const _organizationNamespaceProjectIntegrationsJiraIssuesPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"namespace_id":{"r":true},"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"integrations"],[2,[7,"/"],[2,[6,"jira"],[2,[7,"/"],[2,[6,"issues"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]);
  const _namespaceProjectIntegrationsJiraIssuesPath = /*#__PURE__*/ __jsr.r({"namespace_id":{"r":true},"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"integrations"],[2,[7,"/"],[2,[6,"jira"],[2,[7,"/"],[2,[6,"issues"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

  const { namespacePath, projectPath } = splitProjectFullPath(projectFullPath);
  const { organizationPath, routeArgs } = resolveOrganizationScope(args);

  if (organizationPath) {
    return _organizationNamespaceProjectIntegrationsJiraIssuesPath(organizationPath, namespacePath, projectPath, ...routeArgs);
  }

  return _namespaceProjectIntegrationsJiraIssuesPath(namespacePath, projectPath, ...routeArgs);
};

/**
 * Generates the Rails route:
 *
 * - href: `/:project_full_path/-/integrations/jira/issues/:id(.:format)`
 * - Path helper: `project_integrations_jira_issue_path`
 * - URL helper: `project_integrations_jira_issue_url`
 * - controller#action: `projects/integrations/jira/issues#show`
 *
 * @param {string} projectFullPath
 * @param {any} id
 * @param {object | undefined} options
 * @param {string | null | undefined} options.organizationPath Path of organization to nest under. Pass `null` to remove path from URL params when outside of an organization data context.
 * @returns {string} route path
 */
export const projectIntegrationsJiraIssuePath = /*#__PURE__*/ (projectFullPath, ...args) => {
  const _organizationNamespaceProjectIntegrationsJiraIssuePath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"namespace_id":{"r":true},"project_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"integrations"],[2,[7,"/"],[2,[6,"jira"],[2,[7,"/"],[2,[6,"issues"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]]]);
  const _namespaceProjectIntegrationsJiraIssuePath = /*#__PURE__*/ __jsr.r({"namespace_id":{"r":true},"project_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"integrations"],[2,[7,"/"],[2,[6,"jira"],[2,[7,"/"],[2,[6,"issues"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

  const { namespacePath, projectPath } = splitProjectFullPath(projectFullPath);
  const { organizationPath, routeArgs } = resolveOrganizationScope(args);

  if (organizationPath) {
    return _organizationNamespaceProjectIntegrationsJiraIssuePath(organizationPath, namespacePath, projectPath, ...routeArgs);
  }

  return _namespaceProjectIntegrationsJiraIssuePath(namespacePath, projectPath, ...routeArgs);
};

/**
 * Generates the Rails route:
 *
 * - href: `/:project_full_path/-/integrations/zentao/issues(.:format)`
 * - Path helper: `project_integrations_zentao_issues_path`
 * - URL helper: `project_integrations_zentao_issues_url`
 * - controller#action: `projects/integrations/zentao/issues#index`
 *
 * @param {string} projectFullPath
 * @param {object | undefined} options
 * @param {string | null | undefined} options.organizationPath Path of organization to nest under. Pass `null` to remove path from URL params when outside of an organization data context.
 * @returns {string} route path
 */
export const projectIntegrationsZentaoIssuesPath = /*#__PURE__*/ (projectFullPath, ...args) => {
  const _organizationNamespaceProjectIntegrationsZentaoIssuesPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"namespace_id":{"r":true},"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"integrations"],[2,[7,"/"],[2,[6,"zentao"],[2,[7,"/"],[2,[6,"issues"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]);
  const _namespaceProjectIntegrationsZentaoIssuesPath = /*#__PURE__*/ __jsr.r({"namespace_id":{"r":true},"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"integrations"],[2,[7,"/"],[2,[6,"zentao"],[2,[7,"/"],[2,[6,"issues"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

  const { namespacePath, projectPath } = splitProjectFullPath(projectFullPath);
  const { organizationPath, routeArgs } = resolveOrganizationScope(args);

  if (organizationPath) {
    return _organizationNamespaceProjectIntegrationsZentaoIssuesPath(organizationPath, namespacePath, projectPath, ...routeArgs);
  }

  return _namespaceProjectIntegrationsZentaoIssuesPath(namespacePath, projectPath, ...routeArgs);
};

/**
 * Generates the Rails route:
 *
 * - href: `/:project_full_path/-/integrations/zentao/issues/:id(.:format)`
 * - Path helper: `project_integrations_zentao_issue_path`
 * - URL helper: `project_integrations_zentao_issue_url`
 * - controller#action: `projects/integrations/zentao/issues#show`
 *
 * @param {string} projectFullPath
 * @param {any} id
 * @param {object | undefined} options
 * @param {string | null | undefined} options.organizationPath Path of organization to nest under. Pass `null` to remove path from URL params when outside of an organization data context.
 * @returns {string} route path
 */
export const projectIntegrationsZentaoIssuePath = /*#__PURE__*/ (projectFullPath, ...args) => {
  const _organizationNamespaceProjectIntegrationsZentaoIssuePath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"namespace_id":{"r":true},"project_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"integrations"],[2,[7,"/"],[2,[6,"zentao"],[2,[7,"/"],[2,[6,"issues"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]]]);
  const _namespaceProjectIntegrationsZentaoIssuePath = /*#__PURE__*/ __jsr.r({"namespace_id":{"r":true},"project_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"integrations"],[2,[7,"/"],[2,[6,"zentao"],[2,[7,"/"],[2,[6,"issues"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

  const { namespacePath, projectPath } = splitProjectFullPath(projectFullPath);
  const { organizationPath, routeArgs } = resolveOrganizationScope(args);

  if (organizationPath) {
    return _organizationNamespaceProjectIntegrationsZentaoIssuePath(organizationPath, namespacePath, projectPath, ...routeArgs);
  }

  return _namespaceProjectIntegrationsZentaoIssuePath(namespacePath, projectPath, ...routeArgs);
};

/**
 * Generates the Rails route:
 *
 * - href: `/:project_full_path/-/iterations(.:format)`
 * - Path helper: `project_iterations_path`
 * - URL helper: `project_iterations_url`
 * - controller#action: `projects/iterations#index`
 *
 * @param {string} projectFullPath
 * @param {object | undefined} options
 * @param {string | null | undefined} options.organizationPath Path of organization to nest under. Pass `null` to remove path from URL params when outside of an organization data context.
 * @returns {string} route path
 */
export const projectIterationsPath = /*#__PURE__*/ (projectFullPath, ...args) => {
  const _organizationNamespaceProjectIterationsPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"namespace_id":{"r":true},"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"iterations"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);
  const _namespaceProjectIterationsPath = /*#__PURE__*/ __jsr.r({"namespace_id":{"r":true},"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"iterations"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

  const { namespacePath, projectPath } = splitProjectFullPath(projectFullPath);
  const { organizationPath, routeArgs } = resolveOrganizationScope(args);

  if (organizationPath) {
    return _organizationNamespaceProjectIterationsPath(organizationPath, namespacePath, projectPath, ...routeArgs);
  }

  return _namespaceProjectIterationsPath(namespacePath, projectPath, ...routeArgs);
};

/**
 * Generates the Rails route:
 *
 * - href: `/:project_full_path/-/iterations/:id(.:format)`
 * - Path helper: `project_iteration_path`
 * - URL helper: `project_iteration_url`
 * - controller#action: `projects/iterations#show`
 *
 * @param {string} projectFullPath
 * @param {any} id
 * @param {object | undefined} options
 * @param {string | null | undefined} options.organizationPath Path of organization to nest under. Pass `null` to remove path from URL params when outside of an organization data context.
 * @returns {string} route path
 */
export const projectIterationPath = /*#__PURE__*/ (projectFullPath, ...args) => {
  const _organizationNamespaceProjectIterationPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"namespace_id":{"r":true},"project_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"iterations"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);
  const _namespaceProjectIterationPath = /*#__PURE__*/ __jsr.r({"namespace_id":{"r":true},"project_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"iterations"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

  const { namespacePath, projectPath } = splitProjectFullPath(projectFullPath);
  const { organizationPath, routeArgs } = resolveOrganizationScope(args);

  if (organizationPath) {
    return _organizationNamespaceProjectIterationPath(organizationPath, namespacePath, projectPath, ...routeArgs);
  }

  return _namespaceProjectIterationPath(namespacePath, projectPath, ...routeArgs);
};

/**
 * Generates the Rails route:
 *
 * - href: `/:project_full_path/-/cadences(/*vueroute)/:iteration_cadence_id/iterations(.:format)`
 * - Path helper: `project_iteration_cadence_iterations_path`
 * - URL helper: `project_iteration_cadence_iterations_url`
 * - controller#action: `projects/iteration_cadences#index`
 *
 * @param {string} projectFullPath
 * @param {any} iterationCadenceId
 * @param {object | undefined} options
 * @param {string | null | undefined} options.organizationPath Path of organization to nest under. Pass `null` to remove path from URL params when outside of an organization data context.
 * @returns {string} route path
 */
export const projectIterationCadenceIterationsPath = /*#__PURE__*/ (projectFullPath, ...args) => {
  const _organizationNamespaceProjectIterationCadenceIterationsPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"namespace_id":{"r":true},"project_id":{"r":true},"vueroute":{},"iteration_cadence_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"cadences"],[2,[1,[2,[7,"/"],[5,[3,"vueroute"]]]],[2,[7,"/"],[2,[3,"iteration_cadence_id"],[2,[7,"/"],[2,[6,"iterations"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]]);
  const _namespaceProjectIterationCadenceIterationsPath = /*#__PURE__*/ __jsr.r({"namespace_id":{"r":true},"project_id":{"r":true},"vueroute":{},"iteration_cadence_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"cadences"],[2,[1,[2,[7,"/"],[5,[3,"vueroute"]]]],[2,[7,"/"],[2,[3,"iteration_cadence_id"],[2,[7,"/"],[2,[6,"iterations"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]);

  const { namespacePath, projectPath } = splitProjectFullPath(projectFullPath);
  const { organizationPath, routeArgs } = resolveOrganizationScope(args);

  if (organizationPath) {
    return _organizationNamespaceProjectIterationCadenceIterationsPath(organizationPath, namespacePath, projectPath, ...routeArgs);
  }

  return _namespaceProjectIterationCadenceIterationsPath(namespacePath, projectPath, ...routeArgs);
};

/**
 * Generates the Rails route:
 *
 * - href: `/:project_full_path/-/cadences(/*vueroute)/:iteration_cadence_id/iterations/:id(.:format)`
 * - Path helper: `project_iteration_cadence_iteration_path`
 * - URL helper: `project_iteration_cadence_iteration_url`
 * - controller#action: `projects/iteration_cadences#index`
 *
 * @param {string} projectFullPath
 * @param {any} iterationCadenceId
 * @param {any} id
 * @param {object | undefined} options
 * @param {string | null | undefined} options.organizationPath Path of organization to nest under. Pass `null` to remove path from URL params when outside of an organization data context.
 * @returns {string} route path
 */
export const projectIterationCadenceIterationPath = /*#__PURE__*/ (projectFullPath, ...args) => {
  const _organizationNamespaceProjectIterationCadenceIterationPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"namespace_id":{"r":true},"project_id":{"r":true},"vueroute":{},"iteration_cadence_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"cadences"],[2,[1,[2,[7,"/"],[5,[3,"vueroute"]]]],[2,[7,"/"],[2,[3,"iteration_cadence_id"],[2,[7,"/"],[2,[6,"iterations"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]]]]);
  const _namespaceProjectIterationCadenceIterationPath = /*#__PURE__*/ __jsr.r({"namespace_id":{"r":true},"project_id":{"r":true},"vueroute":{},"iteration_cadence_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"cadences"],[2,[1,[2,[7,"/"],[5,[3,"vueroute"]]]],[2,[7,"/"],[2,[3,"iteration_cadence_id"],[2,[7,"/"],[2,[6,"iterations"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]);

  const { namespacePath, projectPath } = splitProjectFullPath(projectFullPath);
  const { organizationPath, routeArgs } = resolveOrganizationScope(args);

  if (organizationPath) {
    return _organizationNamespaceProjectIterationCadenceIterationPath(organizationPath, namespacePath, projectPath, ...routeArgs);
  }

  return _namespaceProjectIterationCadenceIterationPath(namespacePath, projectPath, ...routeArgs);
};

/**
 * Generates the Rails route:
 *
 * - href: `/:project_full_path/-/cadences(/*vueroute)(.:format)`
 * - Path helper: `project_iteration_cadences_path`
 * - URL helper: `project_iteration_cadences_url`
 * - controller#action: `projects/iteration_cadences#index`
 *
 * @param {string} projectFullPath
 * @param {object | undefined} options
 * @param {string | null | undefined} options.organizationPath Path of organization to nest under. Pass `null` to remove path from URL params when outside of an organization data context.
 * @returns {string} route path
 */
export const projectIterationCadencesPath = /*#__PURE__*/ (projectFullPath, ...args) => {
  const _organizationNamespaceProjectIterationCadencesPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"namespace_id":{"r":true},"project_id":{"r":true},"vueroute":{},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"cadences"],[2,[1,[2,[7,"/"],[5,[3,"vueroute"]]]],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]);
  const _namespaceProjectIterationCadencesPath = /*#__PURE__*/ __jsr.r({"namespace_id":{"r":true},"project_id":{"r":true},"vueroute":{},"format":{}}, [2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"cadences"],[2,[1,[2,[7,"/"],[5,[3,"vueroute"]]]],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

  const { namespacePath, projectPath } = splitProjectFullPath(projectFullPath);
  const { organizationPath, routeArgs } = resolveOrganizationScope(args);

  if (organizationPath) {
    return _organizationNamespaceProjectIterationCadencesPath(organizationPath, namespacePath, projectPath, ...routeArgs);
  }

  return _namespaceProjectIterationCadencesPath(namespacePath, projectPath, ...routeArgs);
};

/**
 * Generates the Rails route:
 *
 * - href: `/:project_full_path/-/cadences(/*vueroute)/new(.:format)`
 * - Path helper: `new_project_iteration_cadence_path`
 * - URL helper: `new_project_iteration_cadence_url`
 * - controller#action: `projects/iteration_cadences#index`
 *
 * @param {string} projectFullPath
 * @param {object | undefined} options
 * @param {string | null | undefined} options.organizationPath Path of organization to nest under. Pass `null` to remove path from URL params when outside of an organization data context.
 * @returns {string} route path
 */
export const newProjectIterationCadencePath = /*#__PURE__*/ (projectFullPath, ...args) => {
  const _newOrganizationNamespaceProjectIterationCadencePath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"namespace_id":{"r":true},"project_id":{"r":true},"vueroute":{},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"cadences"],[2,[1,[2,[7,"/"],[5,[3,"vueroute"]]]],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]);
  const _newNamespaceProjectIterationCadencePath = /*#__PURE__*/ __jsr.r({"namespace_id":{"r":true},"project_id":{"r":true},"vueroute":{},"format":{}}, [2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"cadences"],[2,[1,[2,[7,"/"],[5,[3,"vueroute"]]]],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]);

  const { namespacePath, projectPath } = splitProjectFullPath(projectFullPath);
  const { organizationPath, routeArgs } = resolveOrganizationScope(args);

  if (organizationPath) {
    return _newOrganizationNamespaceProjectIterationCadencePath(organizationPath, namespacePath, projectPath, ...routeArgs);
  }

  return _newNamespaceProjectIterationCadencePath(namespacePath, projectPath, ...routeArgs);
};

/**
 * Generates the Rails route:
 *
 * - href: `/:project_full_path/-/cadences(/*vueroute)/:id/edit(.:format)`
 * - Path helper: `edit_project_iteration_cadence_path`
 * - URL helper: `edit_project_iteration_cadence_url`
 * - controller#action: `projects/iteration_cadences#index`
 *
 * @param {string} projectFullPath
 * @param {any} id
 * @param {object | undefined} options
 * @param {string | null | undefined} options.organizationPath Path of organization to nest under. Pass `null` to remove path from URL params when outside of an organization data context.
 * @returns {string} route path
 */
export const editProjectIterationCadencePath = /*#__PURE__*/ (projectFullPath, ...args) => {
  const _editOrganizationNamespaceProjectIterationCadencePath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"namespace_id":{"r":true},"project_id":{"r":true},"vueroute":{},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"cadences"],[2,[1,[2,[7,"/"],[5,[3,"vueroute"]]]],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]]);
  const _editNamespaceProjectIterationCadencePath = /*#__PURE__*/ __jsr.r({"namespace_id":{"r":true},"project_id":{"r":true},"vueroute":{},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"cadences"],[2,[1,[2,[7,"/"],[5,[3,"vueroute"]]]],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]);

  const { namespacePath, projectPath } = splitProjectFullPath(projectFullPath);
  const { organizationPath, routeArgs } = resolveOrganizationScope(args);

  if (organizationPath) {
    return _editOrganizationNamespaceProjectIterationCadencePath(organizationPath, namespacePath, projectPath, ...routeArgs);
  }

  return _editNamespaceProjectIterationCadencePath(namespacePath, projectPath, ...routeArgs);
};

/**
 * Generates the Rails route:
 *
 * - href: `/:project_full_path/-/cadences(/*vueroute)/:id(.:format)`
 * - Path helper: `project_iteration_cadence_path`
 * - URL helper: `project_iteration_cadence_url`
 * - controller#action: `projects/iteration_cadences#index`
 *
 * @param {string} projectFullPath
 * @param {any} id
 * @param {object | undefined} options
 * @param {string | null | undefined} options.organizationPath Path of organization to nest under. Pass `null` to remove path from URL params when outside of an organization data context.
 * @returns {string} route path
 */
export const projectIterationCadencePath = /*#__PURE__*/ (projectFullPath, ...args) => {
  const _organizationNamespaceProjectIterationCadencePath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"namespace_id":{"r":true},"project_id":{"r":true},"vueroute":{},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"cadences"],[2,[1,[2,[7,"/"],[5,[3,"vueroute"]]]],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]);
  const _namespaceProjectIterationCadencePath = /*#__PURE__*/ __jsr.r({"namespace_id":{"r":true},"project_id":{"r":true},"vueroute":{},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"cadences"],[2,[1,[2,[7,"/"],[5,[3,"vueroute"]]]],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]);

  const { namespacePath, projectPath } = splitProjectFullPath(projectFullPath);
  const { organizationPath, routeArgs } = resolveOrganizationScope(args);

  if (organizationPath) {
    return _organizationNamespaceProjectIterationCadencePath(organizationPath, namespacePath, projectPath, ...routeArgs);
  }

  return _namespaceProjectIterationCadencePath(namespacePath, projectPath, ...routeArgs);
};

/**
 * Generates the Rails route:
 *
 * - href: `/:project_full_path/-/oncall_schedules(.:format)`
 * - Path helper: `project_incident_management_oncall_schedules_path`
 * - URL helper: `project_incident_management_oncall_schedules_url`
 * - controller#action: `projects/incident_management/oncall_schedules#index`
 *
 * @param {string} projectFullPath
 * @param {object | undefined} options
 * @param {string | null | undefined} options.organizationPath Path of organization to nest under. Pass `null` to remove path from URL params when outside of an organization data context.
 * @returns {string} route path
 */
export const projectIncidentManagementOncallSchedulesPath = /*#__PURE__*/ (projectFullPath, ...args) => {
  const _organizationNamespaceProjectIncidentManagementOncallSchedulesPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"namespace_id":{"r":true},"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"oncall_schedules"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);
  const _namespaceProjectIncidentManagementOncallSchedulesPath = /*#__PURE__*/ __jsr.r({"namespace_id":{"r":true},"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"oncall_schedules"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

  const { namespacePath, projectPath } = splitProjectFullPath(projectFullPath);
  const { organizationPath, routeArgs } = resolveOrganizationScope(args);

  if (organizationPath) {
    return _organizationNamespaceProjectIncidentManagementOncallSchedulesPath(organizationPath, namespacePath, projectPath, ...routeArgs);
  }

  return _namespaceProjectIncidentManagementOncallSchedulesPath(namespacePath, projectPath, ...routeArgs);
};

/**
 * Generates the Rails route:
 *
 * - href: `/:project_full_path/-/escalation_policies(.:format)`
 * - Path helper: `project_incident_management_escalation_policies_path`
 * - URL helper: `project_incident_management_escalation_policies_url`
 * - controller#action: `projects/incident_management/escalation_policies#index`
 *
 * @param {string} projectFullPath
 * @param {object | undefined} options
 * @param {string | null | undefined} options.organizationPath Path of organization to nest under. Pass `null` to remove path from URL params when outside of an organization data context.
 * @returns {string} route path
 */
export const projectIncidentManagementEscalationPoliciesPath = /*#__PURE__*/ (projectFullPath, ...args) => {
  const _organizationNamespaceProjectIncidentManagementEscalationPoliciesPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"namespace_id":{"r":true},"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"escalation_policies"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);
  const _namespaceProjectIncidentManagementEscalationPoliciesPath = /*#__PURE__*/ __jsr.r({"namespace_id":{"r":true},"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"escalation_policies"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

  const { namespacePath, projectPath } = splitProjectFullPath(projectFullPath);
  const { organizationPath, routeArgs } = resolveOrganizationScope(args);

  if (organizationPath) {
    return _organizationNamespaceProjectIncidentManagementEscalationPoliciesPath(organizationPath, namespacePath, projectPath, ...routeArgs);
  }

  return _namespaceProjectIncidentManagementEscalationPoliciesPath(namespacePath, projectPath, ...routeArgs);
};

/**
 * Generates the Rails route:
 *
 * - href: `/:project_full_path/-/settings/work_items(.:format)`
 * - Path helper: `project_settings_work_items_path`
 * - URL helper: `project_settings_work_items_url`
 * - controller#action: `projects/settings/work_items#show`
 *
 * @param {string} projectFullPath
 * @param {object | undefined} options
 * @param {string | null | undefined} options.organizationPath Path of organization to nest under. Pass `null` to remove path from URL params when outside of an organization data context.
 * @returns {string} route path
 */
export const projectSettingsWorkItemsPath = /*#__PURE__*/ (projectFullPath, ...args) => {
  const _organizationNamespaceProjectSettingsWorkItemsPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"namespace_id":{"r":true},"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"work_items"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);
  const _namespaceProjectSettingsWorkItemsPath = /*#__PURE__*/ __jsr.r({"namespace_id":{"r":true},"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"work_items"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

  const { namespacePath, projectPath } = splitProjectFullPath(projectFullPath);
  const { organizationPath, routeArgs } = resolveOrganizationScope(args);

  if (organizationPath) {
    return _organizationNamespaceProjectSettingsWorkItemsPath(organizationPath, namespacePath, projectPath, ...routeArgs);
  }

  return _namespaceProjectSettingsWorkItemsPath(namespacePath, projectPath, ...routeArgs);
};

/**
 * Generates the Rails route:
 *
 * - href: `/:project_full_path/-/settings/gitlab_duo/agent_config(.:format)`
 * - Path helper: `project_settings_gitlab_duo_agent_config_path`
 * - URL helper: `project_settings_gitlab_duo_agent_config_url`
 * - controller#action: `projects/settings/gitlab_duo/agent_config#create`
 *
 * @param {string} projectFullPath
 * @param {object | undefined} options
 * @param {string | null | undefined} options.organizationPath Path of organization to nest under. Pass `null` to remove path from URL params when outside of an organization data context.
 * @returns {string} route path
 */
export const projectSettingsGitlabDuoAgentConfigPath = /*#__PURE__*/ (projectFullPath, ...args) => {
  const _organizationNamespaceProjectSettingsGitlabDuoAgentConfigPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"namespace_id":{"r":true},"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"gitlab_duo"],[2,[7,"/"],[2,[6,"agent_config"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]);
  const _namespaceProjectSettingsGitlabDuoAgentConfigPath = /*#__PURE__*/ __jsr.r({"namespace_id":{"r":true},"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"gitlab_duo"],[2,[7,"/"],[2,[6,"agent_config"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

  const { namespacePath, projectPath } = splitProjectFullPath(projectFullPath);
  const { organizationPath, routeArgs } = resolveOrganizationScope(args);

  if (organizationPath) {
    return _organizationNamespaceProjectSettingsGitlabDuoAgentConfigPath(organizationPath, namespacePath, projectPath, ...routeArgs);
  }

  return _namespaceProjectSettingsGitlabDuoAgentConfigPath(namespacePath, projectPath, ...routeArgs);
};

/**
 * Generates the Rails route:
 *
 * - href: `/:project_full_path/-/secrets(/*vueroute)(.:format)`
 * - Path helper: `project_secrets_path`
 * - URL helper: `project_secrets_url`
 * - controller#action: `projects/secrets#index`
 *
 * @param {string} projectFullPath
 * @param {object | undefined} options
 * @param {string | null | undefined} options.organizationPath Path of organization to nest under. Pass `null` to remove path from URL params when outside of an organization data context.
 * @returns {string} route path
 */
export const projectSecretsPath = /*#__PURE__*/ (projectFullPath, ...args) => {
  const _organizationNamespaceProjectSecretsPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"namespace_id":{"r":true},"project_id":{"r":true},"vueroute":{},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"secrets"],[2,[1,[2,[7,"/"],[5,[3,"vueroute"]]]],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]);
  const _namespaceProjectSecretsPath = /*#__PURE__*/ __jsr.r({"namespace_id":{"r":true},"project_id":{"r":true},"vueroute":{},"format":{}}, [2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"secrets"],[2,[1,[2,[7,"/"],[5,[3,"vueroute"]]]],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

  const { namespacePath, projectPath } = splitProjectFullPath(projectFullPath);
  const { organizationPath, routeArgs } = resolveOrganizationScope(args);

  if (organizationPath) {
    return _organizationNamespaceProjectSecretsPath(organizationPath, namespacePath, projectPath, ...routeArgs);
  }

  return _namespaceProjectSecretsPath(namespacePath, projectPath, ...routeArgs);
};

/**
 * Generates the Rails route:
 *
 * - href: `/:project_full_path/-/tracing(.:format)`
 * - Path helper: `project_tracing_index_path`
 * - URL helper: `project_tracing_index_url`
 * - controller#action: `projects/tracing#index`
 *
 * @param {string} projectFullPath
 * @param {object | undefined} options
 * @param {string | null | undefined} options.organizationPath Path of organization to nest under. Pass `null` to remove path from URL params when outside of an organization data context.
 * @returns {string} route path
 */
export const projectTracingIndexPath = /*#__PURE__*/ (projectFullPath, ...args) => {
  const _organizationNamespaceProjectTracingIndexPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"namespace_id":{"r":true},"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"tracing"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);
  const _namespaceProjectTracingIndexPath = /*#__PURE__*/ __jsr.r({"namespace_id":{"r":true},"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"tracing"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

  const { namespacePath, projectPath } = splitProjectFullPath(projectFullPath);
  const { organizationPath, routeArgs } = resolveOrganizationScope(args);

  if (organizationPath) {
    return _organizationNamespaceProjectTracingIndexPath(organizationPath, namespacePath, projectPath, ...routeArgs);
  }

  return _namespaceProjectTracingIndexPath(namespacePath, projectPath, ...routeArgs);
};

/**
 * Generates the Rails route:
 *
 * - href: `/:project_full_path/-/tracing/:id(.:format)`
 * - Path helper: `project_tracing_path`
 * - URL helper: `project_tracing_url`
 * - controller#action: `projects/tracing#show`
 *
 * @param {string} projectFullPath
 * @param {any} id
 * @param {object | undefined} options
 * @param {string | null | undefined} options.organizationPath Path of organization to nest under. Pass `null` to remove path from URL params when outside of an organization data context.
 * @returns {string} route path
 */
export const projectTracingPath = /*#__PURE__*/ (projectFullPath, ...args) => {
  const _organizationNamespaceProjectTracingPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"namespace_id":{"r":true},"project_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"tracing"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);
  const _namespaceProjectTracingPath = /*#__PURE__*/ __jsr.r({"namespace_id":{"r":true},"project_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"tracing"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

  const { namespacePath, projectPath } = splitProjectFullPath(projectFullPath);
  const { organizationPath, routeArgs } = resolveOrganizationScope(args);

  if (organizationPath) {
    return _organizationNamespaceProjectTracingPath(organizationPath, namespacePath, projectPath, ...routeArgs);
  }

  return _namespaceProjectTracingPath(namespacePath, projectPath, ...routeArgs);
};

/**
 * Generates the Rails route:
 *
 * - href: `/:project_full_path/-/metrics(.:format)`
 * - Path helper: `project_metrics_path`
 * - URL helper: `project_metrics_url`
 * - controller#action: `projects/metrics#index`
 *
 * @param {string} projectFullPath
 * @param {object | undefined} options
 * @param {string | null | undefined} options.organizationPath Path of organization to nest under. Pass `null` to remove path from URL params when outside of an organization data context.
 * @returns {string} route path
 */
export const projectMetricsPath = /*#__PURE__*/ (projectFullPath, ...args) => {
  const _organizationNamespaceProjectMetricsPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"namespace_id":{"r":true},"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"metrics"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);
  const _namespaceProjectMetricsPath = /*#__PURE__*/ __jsr.r({"namespace_id":{"r":true},"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"metrics"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

  const { namespacePath, projectPath } = splitProjectFullPath(projectFullPath);
  const { organizationPath, routeArgs } = resolveOrganizationScope(args);

  if (organizationPath) {
    return _organizationNamespaceProjectMetricsPath(organizationPath, namespacePath, projectPath, ...routeArgs);
  }

  return _namespaceProjectMetricsPath(namespacePath, projectPath, ...routeArgs);
};

/**
 * Generates the Rails route:
 *
 * - href: `/:project_full_path/-/metrics/:id(.:format)`
 * - Path helper: `project_metric_path`
 * - URL helper: `project_metric_url`
 * - controller#action: `projects/metrics#show`
 *
 * @param {string} projectFullPath
 * @param {any} id
 * @param {object | undefined} options
 * @param {string | null | undefined} options.organizationPath Path of organization to nest under. Pass `null` to remove path from URL params when outside of an organization data context.
 * @returns {string} route path
 */
export const projectMetricPath = /*#__PURE__*/ (projectFullPath, ...args) => {
  const _organizationNamespaceProjectMetricPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"namespace_id":{"r":true},"project_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"metrics"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);
  const _namespaceProjectMetricPath = /*#__PURE__*/ __jsr.r({"namespace_id":{"r":true},"project_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"metrics"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

  const { namespacePath, projectPath } = splitProjectFullPath(projectFullPath);
  const { organizationPath, routeArgs } = resolveOrganizationScope(args);

  if (organizationPath) {
    return _organizationNamespaceProjectMetricPath(organizationPath, namespacePath, projectPath, ...routeArgs);
  }

  return _namespaceProjectMetricPath(namespacePath, projectPath, ...routeArgs);
};

/**
 * Generates the Rails route:
 *
 * - href: `/:project_full_path/-/logs(.:format)`
 * - Path helper: `project_logs_path`
 * - URL helper: `project_logs_url`
 * - controller#action: `projects/logs#index`
 *
 * @param {string} projectFullPath
 * @param {object | undefined} options
 * @param {string | null | undefined} options.organizationPath Path of organization to nest under. Pass `null` to remove path from URL params when outside of an organization data context.
 * @returns {string} route path
 */
export const projectLogsPath = /*#__PURE__*/ (projectFullPath, ...args) => {
  const _organizationNamespaceProjectLogsPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"namespace_id":{"r":true},"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"logs"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);
  const _namespaceProjectLogsPath = /*#__PURE__*/ __jsr.r({"namespace_id":{"r":true},"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"logs"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

  const { namespacePath, projectPath } = splitProjectFullPath(projectFullPath);
  const { organizationPath, routeArgs } = resolveOrganizationScope(args);

  if (organizationPath) {
    return _organizationNamespaceProjectLogsPath(organizationPath, namespacePath, projectPath, ...routeArgs);
  }

  return _namespaceProjectLogsPath(namespacePath, projectPath, ...routeArgs);
};

/**
 * Generates the Rails route:
 *
 * - href: `/:project_full_path/-/merge_trains(.:format)`
 * - Path helper: `project_merge_trains_path`
 * - URL helper: `project_merge_trains_url`
 * - controller#action: `projects/merge_trains#index`
 *
 * @param {string} projectFullPath
 * @param {object | undefined} options
 * @param {string | null | undefined} options.organizationPath Path of organization to nest under. Pass `null` to remove path from URL params when outside of an organization data context.
 * @returns {string} route path
 */
export const projectMergeTrainsPath = /*#__PURE__*/ (projectFullPath, ...args) => {
  const _organizationNamespaceProjectMergeTrainsPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"namespace_id":{"r":true},"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"merge_trains"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);
  const _namespaceProjectMergeTrainsPath = /*#__PURE__*/ __jsr.r({"namespace_id":{"r":true},"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"merge_trains"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

  const { namespacePath, projectPath } = splitProjectFullPath(projectFullPath);
  const { organizationPath, routeArgs } = resolveOrganizationScope(args);

  if (organizationPath) {
    return _organizationNamespaceProjectMergeTrainsPath(organizationPath, namespacePath, projectPath, ...routeArgs);
  }

  return _namespaceProjectMergeTrainsPath(namespacePath, projectPath, ...routeArgs);
};

/**
 * Generates the Rails route:
 *
 * - href: `/:project_full_path/-/transfer_personal(.:format)`
 * - Path helper: `project_transfer_personal_path`
 * - URL helper: `project_transfer_personal_url`
 * - controller#action: `projects#transfer_personal`
 *
 * @param {string} projectFullPath
 * @param {object | undefined} options
 * @param {string | null | undefined} options.organizationPath Path of organization to nest under. Pass `null` to remove path from URL params when outside of an organization data context.
 * @returns {string} route path
 */
export const projectTransferPersonalPath = /*#__PURE__*/ (projectFullPath, ...args) => {
  const _organizationNamespaceProjectTransferPersonalPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"namespace_id":{"r":true},"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"transfer_personal"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);
  const _namespaceProjectTransferPersonalPath = /*#__PURE__*/ __jsr.r({"namespace_id":{"r":true},"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"transfer_personal"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

  const { namespacePath, projectPath } = splitProjectFullPath(projectFullPath);
  const { organizationPath, routeArgs } = resolveOrganizationScope(args);

  if (organizationPath) {
    return _organizationNamespaceProjectTransferPersonalPath(organizationPath, namespacePath, projectPath, ...routeArgs);
  }

  return _namespaceProjectTransferPersonalPath(namespacePath, projectPath, ...routeArgs);
};

/**
 * Generates the Rails route:
 *
 * - href: `/:project_full_path/path_locks/toggle(.:format)`
 * - Path helper: `toggle_project_path_locks_path`
 * - URL helper: `toggle_project_path_locks_url`
 * - controller#action: `projects/path_locks#toggle`
 *
 * @param {string} projectFullPath
 * @param {object | undefined} options
 * @param {string | null | undefined} options.organizationPath Path of organization to nest under. Pass `null` to remove path from URL params when outside of an organization data context.
 * @returns {string} route path
 */
export const toggleProjectPathLocksPath = /*#__PURE__*/ (projectFullPath, ...args) => {
  const _toggleOrganizationNamespaceProjectPathLocksPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"namespace_id":{"r":true},"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"path_locks"],[2,[7,"/"],[2,[6,"toggle"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);
  const _toggleNamespaceProjectPathLocksPath = /*#__PURE__*/ __jsr.r({"namespace_id":{"r":true},"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"path_locks"],[2,[7,"/"],[2,[6,"toggle"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

  const { namespacePath, projectPath } = splitProjectFullPath(projectFullPath);
  const { organizationPath, routeArgs } = resolveOrganizationScope(args);

  if (organizationPath) {
    return _toggleOrganizationNamespaceProjectPathLocksPath(organizationPath, namespacePath, projectPath, ...routeArgs);
  }

  return _toggleNamespaceProjectPathLocksPath(namespacePath, projectPath, ...routeArgs);
};

/**
 * Generates the Rails route:
 *
 * - href: `/:project_full_path/path_locks(.:format)`
 * - Path helper: `project_path_locks_path`
 * - URL helper: `project_path_locks_url`
 * - controller#action: `projects/path_locks#index`
 *
 * @param {string} projectFullPath
 * @param {object | undefined} options
 * @param {string | null | undefined} options.organizationPath Path of organization to nest under. Pass `null` to remove path from URL params when outside of an organization data context.
 * @returns {string} route path
 */
export const projectPathLocksPath = /*#__PURE__*/ (projectFullPath, ...args) => {
  const _organizationNamespaceProjectPathLocksPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"namespace_id":{"r":true},"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"path_locks"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);
  const _namespaceProjectPathLocksPath = /*#__PURE__*/ __jsr.r({"namespace_id":{"r":true},"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"path_locks"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

  const { namespacePath, projectPath } = splitProjectFullPath(projectFullPath);
  const { organizationPath, routeArgs } = resolveOrganizationScope(args);

  if (organizationPath) {
    return _organizationNamespaceProjectPathLocksPath(organizationPath, namespacePath, projectPath, ...routeArgs);
  }

  return _namespaceProjectPathLocksPath(namespacePath, projectPath, ...routeArgs);
};

/**
 * Generates the Rails route:
 *
 * - href: `/:project_full_path/path_locks/:id(.:format)`
 * - Path helper: `project_path_lock_path`
 * - URL helper: `project_path_lock_url`
 * - controller#action: `projects/path_locks#destroy`
 *
 * @param {string} projectFullPath
 * @param {any} id
 * @param {object | undefined} options
 * @param {string | null | undefined} options.organizationPath Path of organization to nest under. Pass `null` to remove path from URL params when outside of an organization data context.
 * @returns {string} route path
 */
export const projectPathLockPath = /*#__PURE__*/ (projectFullPath, ...args) => {
  const _organizationNamespaceProjectPathLockPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"namespace_id":{"r":true},"project_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"path_locks"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);
  const _namespaceProjectPathLockPath = /*#__PURE__*/ __jsr.r({"namespace_id":{"r":true},"project_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"path_locks"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

  const { namespacePath, projectPath } = splitProjectFullPath(projectFullPath);
  const { organizationPath, routeArgs } = resolveOrganizationScope(args);

  if (organizationPath) {
    return _organizationNamespaceProjectPathLockPath(organizationPath, namespacePath, projectPath, ...routeArgs);
  }

  return _namespaceProjectPathLockPath(namespacePath, projectPath, ...routeArgs);
};

/**
 * Generates the Rails route:
 *
 * - href: `/:project_full_path/insights/query(.:format)`
 * - Path helper: `query_project_insights_path`
 * - URL helper: `query_project_insights_url`
 * - controller#action: `projects/insights#query`
 *
 * @param {string} projectFullPath
 * @param {object | undefined} options
 * @param {string | null | undefined} options.organizationPath Path of organization to nest under. Pass `null` to remove path from URL params when outside of an organization data context.
 * @returns {string} route path
 */
export const queryProjectInsightsPath = /*#__PURE__*/ (projectFullPath, ...args) => {
  const _queryOrganizationNamespaceProjectInsightsPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"namespace_id":{"r":true},"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"insights"],[2,[7,"/"],[2,[6,"query"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);
  const _queryNamespaceProjectInsightsPath = /*#__PURE__*/ __jsr.r({"namespace_id":{"r":true},"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"insights"],[2,[7,"/"],[2,[6,"query"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

  const { namespacePath, projectPath } = splitProjectFullPath(projectFullPath);
  const { organizationPath, routeArgs } = resolveOrganizationScope(args);

  if (organizationPath) {
    return _queryOrganizationNamespaceProjectInsightsPath(organizationPath, namespacePath, projectPath, ...routeArgs);
  }

  return _queryNamespaceProjectInsightsPath(namespacePath, projectPath, ...routeArgs);
};

/**
 * Generates the Rails route:
 *
 * - href: `/:project_full_path/insights(.:format)`
 * - Path helper: `project_insights_path`
 * - URL helper: `project_insights_url`
 * - controller#action: `projects/insights#show`
 *
 * @param {string} projectFullPath
 * @param {object | undefined} options
 * @param {string | null | undefined} options.organizationPath Path of organization to nest under. Pass `null` to remove path from URL params when outside of an organization data context.
 * @returns {string} route path
 */
export const projectInsightsPath = /*#__PURE__*/ (projectFullPath, ...args) => {
  const _organizationNamespaceProjectInsightsPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"namespace_id":{"r":true},"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"insights"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);
  const _namespaceProjectInsightsPath = /*#__PURE__*/ __jsr.r({"namespace_id":{"r":true},"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"insights"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

  const { namespacePath, projectPath } = splitProjectFullPath(projectFullPath);
  const { organizationPath, routeArgs } = resolveOrganizationScope(args);

  if (organizationPath) {
    return _organizationNamespaceProjectInsightsPath(organizationPath, namespacePath, projectPath, ...routeArgs);
  }

  return _namespaceProjectInsightsPath(namespacePath, projectPath, ...routeArgs);
};

